var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlijdorp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #efefef;\n      }\n\n      .cls-2 {\n        fill: #e4e4e4;\n      }\n\n      .cls-3 {\n        fill: #919191;\n      }\n\n      .cls-4 {\n        fill: #848484;\n      }\n\n      .cls-5 {\n        fill: #8c8c8c;\n      }\n\n      .cls-6 {\n        fill: #d3d3d3;\n      }\n\n      .cls-7 {\n        fill: #868686;\n      }\n\n      .cls-8 {\n        fill: #838383;\n      }\n\n      .cls-9 {\n        fill: #828282;\n      }\n\n      .cls-10 {\n        fill: #7b7b7b;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m307.28,247.05c.2.62.17,1.36.6,1.87.01.11.02.22.03.32-2.59,2,2.16,4.52,3.79,2.56h1.88c.7,1.14,1.54,1.24,2.5.31l.64.04c4.95,1.69,11,.85,15.64,3.33.09.39.18.78.26,1.16-.76.83-1.1,1.63.13,2.34l-.1.6c-1.13,1.36-2.91,1.05-4.37,1.49-6.46-2.2-13.39-2.11-20.02-3.01-.92-1.27-1.71-1.27-2.5,0-3.16.07-6.28.14-9.36.88-.11-.07-.23-.14-.34-.22-.63.09-1.26.18-1.89.27,0,0,.02-.12.02-.12-1.68.48-3.39.37-5.03.98-.2-.09-.41-.19-.61-.28-.67.46-1.4.76-2.21.85-.2-.07-.4-.15-.61-.22-.1-.16-.19-.33-.29-.49-.11.25-.23.5-.34.75-5.42,1.47-10.92,3.12-16.28,5.13-2.17.4-4.17,1.74-6.26,2.51-1.1.29-2.19,1.02-3.28,1.46l-.09-.02c-10.46,4.78-20.63,10.53-31.66,14.18,0,0,0,0,0,0-3.28,1.24-6.65,2.2-10.02,3.08,0,0,.04.11.04.11-6.05,1.87-12.04,3.31-18.17,4.46-.07-.05-.14-.08-.23-.1-.13.08-.26.16-.39.23-3.27.22-6.42,1.06-9.72,1.34l.02-.13c-1.56.18-3.17.16-4.7.48-4.78,0-9.63.38-14.42-.01l.03-.12c-1.18.03-2.34-.18-3.47-.53.17-1.29-.52-1.68-1.66-1.58-2.14-3.8,2.53-4.9,5.43-4.5.11.04.21.08.32.11.37,1.77,1.99,1,3.01,1.41.18.07.7-.72,1.07-1.12l-.02-.13c1.36.08,2.72.1,4.08.16.94,1.4,1.35.46,2.19-.31,1.67,0,3.34,0,5.01,0,.24.39.47.77.71,1.16.29-.39.57-.77.86-1.16.41-.12.83-.25,1.24-.37.21-.22.41-.44.62-.66.08-.85.28-1.72.69-2.47.65.03,1.22.53,1.83.75l.38-.54c-.54-.49-1.12-.94-1.63-1.46-.08-.83.07-1.6.61-2.25,0-.3-.02-.6-.02-.9l.12.03c.07-.12.15-.23.22-.35,0,0-.01.01-.01.01.11-.31.45-.6.28-.94.1-.21.2-.42.3-.64,1.47-.53,4.22-3.58,1-3.43.16-.76.34-1.5.61-2.22h-.01c.71-.05,1.41-.12,2.5-.22-.67-.58-1.1-.95-1.53-1.31-.09-.41-.17-.83-.26-1.24.11-.21.21-.43.32-.64.7-.4,1.4-.8,2.49-1.43-.82-.23-1.22-.34-1.62-.45,0-.32.01-.64-.07-.95l.12.02c1.03-1.25,4.58-3.6,1.25-4.4.21-.73.43-1.46.64-2.19.66.02,1.32-.04,1.98-.12-.48-.51-.97-1.01-1.49-1.47.15-.51.3-1.03.45-1.54.7-.29,1.41-.58,2.52-1.04-.78-.4-1.21-.62-1.64-.84-.33-.55-.36-1.05.06-1.57,1.39-.35,1.51-.64.62-1.57.09-.43.33-.8.33-1.25.54.08,1.07.16,1.61.24.1-.12.2-.24.3-.36-.47-.49-.94-.98-1.41-1.46.09-.31.18-.62.27-.93.75-.16,1.51-.33,2.55-.55-.67-.94-1.15-1.61-1.63-2.29.1-.32.27-.61.42-.92.62-.33,1.24-.66,1.86-.99-.42-.61-.85-1.22-1.27-1.83.07-1.12.35-2.17.86-3.17,1.25-.22.34-.77.18-1.2.19-.52.38-1.04.56-1.56.8-.2,1.62-.34,2.43-.52.08-.16.15-.33.23-.49-.59-.41-1.19-.82-1.78-1.23,0-.57.09-1.09.43-1.55.78-.14,1.56-.28,2.44-.44-2.6-4.08,3.71-5.16,0-6.46-.09-.31-.17-.62-.26-.93.29-.49.54-1.01.62-1.58.58.05,1.16.09,1.74.14.08-.13.16-.26.23-.39-.55-.44-1.1-.87-1.65-1.31.89-2.97,1.95-5.84,2.82-8.8,0-.2,0-.4,0-.6.64-.85,1.76-1.07,2.75-1.73-.52-.47-1.04-.94-1.55-1.41-.02-.13-.03-.26-.05-.39.66-1.72,3.83-.6,2.46-2.98-1.57-2.49,3.42-2.27.4-4.46-.08-.52-.16-1.03-.24-1.55.24-.4.38-.84.55-1.27h1.76c-.14-1.29-.27-2-.52-3.15.31-.34.63-.68.94-1.03.09,0,.17-.02.26-.03,1.51,1.65,3.81,2.6,3.26,5.48,1.03.99,1.94,2.67,1.75,4.36-1.08,1.05-.64,1.71.64,1.9.34,2.13,1.42,4.17.35,6.25-2.61.52-.79,3.69-1.25,5.64-.19.13-.38.26-.57.4,1.38.95,1.35,2.81,2.12,4.04.29,1.38,1.38,2.34,2.23,3.4-.28.14-.56.28-.84.42.5.55.95.53,1.56.16,4.65,3.74,11.64,2.27,14.85-2.58.42,1.43.68,1.48,2.24.78-.85-.6-1.37-.96-1.89-1.32.19-.72.4-1.43.65-2.12.07-.03.14-.04.22-.05.22-1.35-.03-2.7.15-4.06.46-.51.52-1.26.78-1.89-.38,0-.77.02-1.15.01-.3-.84-.6-1.68-.9-2.52.19-.41.38-.83.57-1.24,1.34-.95-.53-1.96-.36-3.14.3-.59.56-1.2.38-1.87.25-.49.29-1.02.31-1.57.08-.01.15-.02.23-.02.52-2.08.44-4.1,1.02-6.25.08-.01.15-.02.23-.02.22-.83.46-1.64.43-2.5,0,0-.11.02-.11.02,0-.11.02-.21.03-.32.65-.75,1.46-1.32,2.22-1.94.71.29,1.43.5,2.21.61.35.63.94,1.06,1.19,1.76-.76.1-1.44.41-2.13.74.2.34.4.68.6,1.01-.84,1.69.84,3.07.56,4.7-3.76.05-1.24,4.44-1.55,6.58-.5.29-.99.58-1.49.86.39.34.79.68,1.18,1.02.4,1.19.22,2.31-.16,3.48.28-.02.57-.05.85-.07-.11,2.42,1.56,5.52.35,7.56,0,.9-.34,1.71-.73,2.51-1.68.35-1.86.71-1.11,2.23-1.29,2.3-3.4,3.71-5.43,5.28h0c-1.77.97-3.6,1.75-5.64,1.94l.03-.12c-1.27.04-2.47.57-3.77.38-.23-.18-.47-.37-.7-.55-.24,1.59-.74,2.11,1.24,2.73l-.27,1.27c-1.27-.03-.79.93-.89,1.57-2.55.61-.77,4.26-1.25,6.27-3.2.66.07,3.87-.68,5.94-.08,0-.16.02-.25.04-.46-.21-.92-.42-1.37-.64-.09.12-.19.25-.28.37.79.75,1.35,1.5.47,2.49.02.25.69,1.03.64,1.52-.06.09-.08.19-.04.29-.07.52-.31,1.06-.31,1.57-.14.32-.27.64-.41.96-2.51-.01-1.38,3.15-.86,4.77-.95,3.08-.84,6.5-1.98,9.63-.38.23-.76.47-1.15.7.28.29.55.58.83.87.05.87.01,1.69-.3,2.51-1.24,0-1.74.8-1.45,1.83.23.84-.34,2.45,1.52,2.24,1.76.71,1.29-1.47,2.35-1.55,1.3.06,2.37-.58,3.55-.98,0,0-.01.02-.01.02,2.53-1.26,5.23-2.39,7.86-3.41l.45.48c.16-.29.31-.59.47-.88,2.18-1.03,4.37-2.06,6.55-3.09.27.05.54.1.81.15-.06-.15-.12-.31-.19-.46.53-.31,1.07-.62,1.6-.93.28.19.57.38.85.57.18-.98.66-1.59,1.65-1.82,1.02.81,3.05-.13,3.43-1.6,1.38-1.24,3.39-1.33,5.01-2.18.17,2.34,4.22-.65,4.06-1.87.83-.32,1.66-.6,2.52-.84.6,2.2,2.45.24,2.82-1.03,1.36-.48,2.72-.97,4.08-1.45.08.24.16.47.39,1.11.12-.71.17-.98.21-1.26.41-.13.82-.26,1.23-.39.25,2.8,3.91-2.62,6.31-1.85l-.03.12c.35.44.7.89,1.05,1.33.16-.09.31-.18.47-.27,0-.56,0-1.12,0-1.68.3-.23.56-.52.85-.77-.17-.07-.34-.15-.51-.22.01-.31.03-.62.04-.93.4-.24.8-.47,1.21-.71-1.04-.91-1.93-2.26-1.83-3.68.6-.81.36-1.31-.57-1.57,0-.21,0-.42,0-.63.15-.09.3-.18.45-.26-.73-.37-.88-1.15-.87-1.91,1.29-.8,1.24-1.22-.26-2.22-.07-.21-.14-.42-.22-.63l-.13.02c.03-.11.07-.22.1-.32.6-.22,1.19-.44,1.79-.67-.04-.15-.08-.3-.12-.45-.37-.05-.74-.09-1.12-.14-.12-.46-.24-.93-.36-1.39.65-.45,1.29-.91,1.94-1.36,1.88.09,3.39.94,3.31,3.02-1.16.82-1.66,5.84.69,5,.52.65,1.05,1.72,1.62.11.42,0,.83,0,1.25,0,.5,1.6,1,3.2,3.17,3.07l.92,1.51c-.15.77-.81,1.82.86,1.64.33.56-.5,1.92,1.01,1.24,2.16,0,4.49-.79,6.55.01.94.11,1.8-.23,1.72-1.19-.11-1.28-1.13-.1-1.68-.38l-.36-1.57c.16-.13.33-.25.49-.38-.16-.08-.32-.16-.48-.25-.12-.2-.24-.41-.36-.61-1.04-.41-1.36-1.69-2-2.53-.11.05-.22.1-.33.16.09.56.22,1.11.18,1.69-3.71.61-4.54-3.51-6.24-5.93,0,0,0,0,0,0-.23-.49-.46-.97-.69-1.46.57-.98.98-2.13,1.77-2.88.56-.53,1.21-.78,1.15-1.72.16-.49.9-1.03,1.16-1.57-.32-.18-.65-.35-.97-.53.29-1.03.86-1.79,1.88-2.16-.51-.31-1.02-.63-1.53-.94h.01c-.44-.52-.43-1.26-.65-1.89.22-.42.44-.84.66-1.27-.41-.46-.88-.85-1.5-.96-.14-.31-.28-.62-.42-.93l.1.03c1.56-1.8.81-1.74-.93-3.16l-.11.02c-.52-.88-.15-2.16.04-3.16h0c.64-.09,1.6.41,1.58-.88,1.95-.58,3.47.47,3.76,2.44-.97,1.22-.88,1.52.57,1.9,1.68,1.81-1.12,5.69,1.61,6.27.13,1.49-1.17,3.73,1.34,2.76,0,0-.02,0-.02,0,.55,1.22-.04,2.48-.23,3.72.46.04.92.07,1.38.11.12.52.24,1.03.36,1.55-1.04,1.64-.92,2.04.64,2.2.22.63.45,1.27.67,1.9-.06.09-.07.19-.04.29-.84.87-.71,1.24.55,1.58.33,1.04.66,2.07.99,3.11-.18.46-.36.92-.57,1.48.45.04.8.08,1.15.11Zm-84.13,9.71c0-.21-.07-.44.06-.63-.06-1.5.91-2.98-1.45-3.24.05.55.1,1.09.15,1.63-.94,0-1.88,0-2.82,0-.41-.27-.67-.69-.99-1.06.2-.39.4-.78.69-1.35h-1.41c-1.32-2.29-2.64-4.57-3.95-6.86.83-1.28,1.93-2.51.6-4.13,2.11-.99.54-3.16,2.17-4.52,0,0-.04-.01-.04-.01.6.36,1.2.72,2.2,1.31-.17-1.3-.5-1.92-1.51-2.6.43-.8.83-1.61,1.3-2.38.63-.19,1.64.92,1.89-.56,2.72.02,5.43-.15,8.14-.34,0,.1,0,.19,0,.29l.77,1c.2-.11.4-.23.6-.34-2.84-4.95-9.68-6.57-10.49-13.19.22,0,.44,0,.66-.01.28-.22.57-.44.85-.67-.28-.3-.57-.6-.85-.9h-.31c.28-1.78.89-3.94.3-5.51,1.97-1.27.58-2.23-.23-3.25.22-.94.4-1.89.57-2.84.27-.08.55-.16.82-.23l-.03-.25c-.99-.1-2.42-.71-3.31-.33-1.71,3.55-2.6,7.39-2.97,11.3-.11,1.1-.05,2.09-1.18,2.7-.09.23.17,1.13.09,1.54-1.45.57.05,1.53-.29,2.25.42.19.84.37,1.26.56.26.4.51.79.77,1.19-.46,1.91-2.07,2.76-3.42,4.3.03.13.41.86.2,1.15-.97,1.94-2.04,3.53-4.02,4.65.58.63,1.35.85,2.14,1.1-1.51,1.86-5.42,4.27-2.57,6.74.12.46-.12.85-.29,1.26-2.97-.51-1.14,2.97-.33,4.12.38.84,1.03,1.61,2.17.91.85,1.42,1.7,2.85,2.56,4.27-1.84,1.1-1.21,2.69-1.06,3.92-2.86,1.42-2.41,5.14-5.69,5.13-.03,0-.07.17-.19.45.39.29.82.61,1.26.93.11.64.22,1.29.33,1.93-1.77.85-3.72.58-5.63.62-2.6-1.63-3.87,3.6-1.9,4.66-.36,2.44,2.96,1.46,4.44,1.43,1.99-.31,2.78,1.7,4.75,1.91h-.04c.7.99,1.22,2.07,1.85,3.09-.47,1.93-1.41,4.14,1.62,3.25,1.46.97,1.93,2.27,2.7.11.73-.12,1.47-.24,2.2-.35l.58.86c.12-.07.24-.14.35-.22-1.42-4.15-4.2-7.75-6.19-11.66.08-1.43,1.29-2.39,1.58-3.75,2-.81,2.85-2.17,2.39-3.85,1.33-4.59,3.61-3.57,7.55-3.94.38-.42.77-.84,1.18-1.22-.19-.14-.39-.26-.57-.4Zm103.36,1.43c0-.1,0-.21,0-.31h-3.01c0,.1,0,.21,0,.31h3.01Zm-136.93,29.86c.17.1.33.2.5.3l1.14-1.52c-.16-.12-.33-.24-.49-.36-.38.53-.77,1.05-1.15,1.58Zm129.74-30.67c.05-.23.11-.46.16-.7-.54-.06-1.08-.13-1.62-.19l-.09.47c.51.14,1.03.28,1.54.42Zm-103.2,26.88c-.2-.03-.39-.07-.59-.1v1.31c.12.01.25.02.37.03.07-.41.15-.83.22-1.24Zm7.05-24.27c.18.05.36.11.54.16.08-.32.17-.63.25-.95-.75-.35-.61.29-.79.79Zm91.09-3.52c-.5.5.2.76.41.2-.12-.06-.24-.12-.41-.2Zm-111.25,7.75c-.23-.16-.31-.12-.37.15.23.16.31.12.37-.15Zm23.47-3.13c-.23-.15-.32-.12-.37.15.23.15.31.12.37-.15Zm-20.94-24.25c-.15.23-.12.32.15.38.16-.23.12-.31-.15-.38Zm-5.35,51.84c-.23-.15-.32-.12-.37.15.23.15.31.12.37-.15Zm11.46-71.51c.15-.23.12-.32-.15-.37-.15.23-.12.32.15.37Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m248.75,139.2c.07.96.29,1.52,1.33,1.57.11.42.21.83.32,1.25-1.49,5.41.06,11.34-.34,16.94.21.11.42.21.63.32,5.62-2.5,11.7-3.68,17.82-4.07.41.58.8,1.17,1.02,1.86-.02.11-.04.21-.07.32.53,2.52-.16,5.27-.1,7.87-.83,2.5-.83,5.41-2.71,7.53,0,0,0-.01,0-.01-.16.15-.4.26-.39.51-3,2.7-13.3,8.83-14.29,1.99,1.18.06.82-.83.89-1.46,2.33-1.39,5.06-1.92,7.57-2.9.81-1.35,2.35-2.43,2.45-4.08.08-.02.16-.03.25-.04.19-.4.38-.8.41-1.24.18-.07.07-.19.03-.32l-.12.03c.02-.31.03-.62.05-.93.08-.12.16-.23.23-.35,0,0,.11.03.11.03.15-.09.31-.18.46-.26-.16-.14-.33-.26-.48-.41-.09-.66-.04-1.26.3-1.85-.37-.97-.94-.74-1.55-.27,0,.08-.02.16-.02.24-.2,0-.41,0-.61,0l-.29-.45c-.11.19-.21.37-.32.56-2.12.5-4.24.99-6.28,1.77-.94-.92-1.97-.27-2.18,1.08-.45-.08-.86.02-1.26.23,0,.1,0,.21,0,.31-.1.11-.2.22-.31.33-.02.09-.03.19-.03.29-.12.11-.23.22-.35.33-2.22.41-.87,1.85-.84,2.91-1.32,1.41-4.82,1.73-4.42-1.03.71-.65.52-1.48-.57-2.51,0-1.05,0-2.09,0-3.14l.53-.4c-.18-.18-.35-.36-.53-.54,0-3.97,0-7.94,0-11.91.83-.92.83-3.78,0-4.7-.02-.3-.05-.59-.07-.89-.93-1.3-2.4-1.31-3.4,0,.03.1.01.18-.05.26-.83,3.23.68,7.91-1.86,10.31-1.17-.67-1.53-.1-1.54,1.01-2.07.44-4.17.27-6.27.22-.14-.38-.28-.76-.42-1.14-.39.3-.78.6-1.17.9-2.45-.59-3.04-2.74-3.72-4.76-.12-1.14.01-2.27.04-3.41.15-.1.3-.21.45-.31-.15-.1-.3-.21-.45-.31,0-.21,0-.42,0-.63,1.16-.33.7-1.16.57-1.88.17-.27.33-.54.5-.81-.89-.19-1.79-.11-2.69-.13-.21.19-.42.38-.63.58-.21,0-.42,0-.63,0-.46-1.16-.95-.39-1.32.02-.78.88-.44,2.75.65,3.79-.77,7.12-.6,14.58-.52,21.71l.04-.03c-1.18-.02-2.36-.03-3.54-.05-.11-1.2.59-4.32-1.56-3.14.23-1.88-1.42-1.44-2.5-1.6,0-.47-.08-.93-.12-1.4-.93.53-1.96.6-3,.53-.01-.57-.02-1.14-.02-1.71-2.16,0-4.68.63-6.62-.5-.09,0-.18.01-.27.05,0,0,.02-.12.02-.12l-.94.08c-.01.1,0,.2.04.29-.04.18-.08.36-.12.55-.85.89-1,1.69.33,2.27.5,1.34.61,2.82,1.36,4.06v-.04c.68.91,1.03,2.1,2.13,2.57.08,1.58,1.26.72,1.97.9,1.41,1.66,2.43,1.74,4.6,1.24.1.07.21.14.31.21,0,.78,0,1.56,0,2.35-.66.85-.09,1.09.63,1.25.12.21.24.43.35.64-.33.29-.67.59-1,.88-.19.02-.39.04-.58.05-.11.08-.22.17-.34.25-.21,0-.42,0-.63,0-.1-.15-.21-.3-.31-.45-.11.15-.21.3-.32.44-1.11-.38-1.81-1.22-2.5-2.13-.85.08-1.73.51-2.55.12-.19-.35-.39-.71-.58-1.06-.21.22-.42.43-.63.65-.51-.23-1.03-.46-1.54-.69-.02-.08-.04-.17-.07-.25.68-1.39-.9-.83-1.57-.95-.29-.32-.59-.63-.88-.95,0-.1-.02-.21-.03-.31.15-.21.3-.42.45-.63-.27.04-.53.08-.8.12-.27-.36-.54-.73-.8-1.09,0-.1,0-.19.02-.29,1.34-1.86-1.91-2.04-1.56-4.4.08-.37-.26-.98-.28-1.46,2.28-.12.11-4.84-.69-5.74v-.94c1.62-.42,1.82-1.04.82-2.64.01-.17.02-.34.03-.51,3.74-.19,7.35.39,10.98,1.32.13.28.26.55.39.83.18-.17.36-.35.55-.52,1.1.18,2.16.37,3.13.95.04,1.45.85.65,1.49.49,0,0,.07.07.07.07.63.28,1.28.38,1.97.33.42-.43.75-.98,1.34-1.18-.16-.13-.33-.26-.49-.39.81-5.24.26-10.58-.09-15.99,0-.11-.31-.21-.48-.31-.02-.1-.03-.21-.05-.31.63-1.57,2.22-1.84,3.46-2.79.31.05.62.06.93.02.05.36.11.73.19,1.25,2.71-1.45,5.64-1.96,8.18-.03.34.72.67,1.45,1.01,2.17-.19.13-.37.27-.56.4.19.18.38.36.57.54-.65,1.54.33,2.86.26,4.39-.62,1.65-2.19,4.56.99,3.77.52.99,1.04.99,1.56,0,.4-.15.8-.28,1.21-.36.04.05.09.1,0,0,.1.09.05.05,0,0,.03-.2.06-.39.09-.59,2.46-1.6.16-5.15,1.26-7.05.99-1.01.85-1.71.26-2.67,0-.22,0-.44-.01-.66.11-.19.23-.37.34-.56.42-.07.85-.15,1.24-.33.29.4.57.81.86,1.21.34-.5.68-1,1.01-1.49.52,0,1.04,0,1.56,0,.13.18.27.35.4.53.18-.18.36-.35.54-.53,1.47.22,3.14-.19,4.46.55.33.06.55.43.8.65Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m252.67,223.58c.67-.7,1.38-1.37,2.02-2.09,5.82-7.27,11.84-14.42,17.64-21.66,3.51-3.41,4.43-8.38,7.49-12.01,3.92-1.85,13.05-2.29,11.6,4.23.27,1.88-2.16,3.04-1.01,4.86,1.79.83,3.24,2.14,5.33,1.19,3.88-.6,7.83-.84,11.73-.61h.15c4.59,3.08-.28,14.18-4.41,16.33v-.02c-2.58.36-5.17,1.24-7.76,1.28-.58-.6-1.28-1.1-1.63-1.87-.52-4.09,4.61-3.6,7.27-4.64,1.75-1.28,1.6-3.24,1.8-5.07-2.42-.86-5.33.07-7.78.68-3.65.89-6.69-2.34-9.92-3.62-3.63-1.81-.3-5.41.03-8.15l-.55-.45c-2.09.94-2.53,3-3.3,4.94-1.88,4.18-5.27,7.41-8.06,10.97-1.63,3.31-22.74,24.41-16.99,24.72,3.55-.67,4.78-4.56,8.28-5.26.28.72.56,1.45.84,2.17-.36.78-.73,1.57-1.09,2.35.18.14.37.28.55.43,2.7-4.15,7.36-3.37,11.61-3.79,5.12-.11,9.92-4.13,14.84-2.74.17,1.67.12,3.52-1.31,4.62,0,0,0-.02,0-.02-5.44,3.12-11.93,4.19-18.06,4.13-1.13-.28-1.85.06-2.5.9-3.75,4.28-9.88,3.53-14.95,2.94-7.4-.28-5.37-10.76-1.86-14.73Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m330.16,327.28c-2.66,1.94-5.77,2.52-9.01,2.27.55,8.21-1.05,6.04-7.52,6.12-.89-7.88.62-16.78-.33-24.95.11-.1.22-.2.33-.31.1,0,.18-.03.26-.09,5.81.32,13.21-1.65,17.52,3.22,2.21,4.28,2.5,10.15-1.24,13.73Zm-9.07-10.01c-.02,3.36-.73,7.1,3.6,4.22,1.23-3.37.06-4.74-3.6-4.22Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m267.59,345.45c.92.72,1.77,1.43,2.06,2.61-.02.11.02.19.1.26.3,2.75-1.13,5.79-4.35,5.37-.94-.86-1.87-1.71-2.81-2.57-.21-2.46.19-6.03,3.43-5.88v2.08c-2.26-.3-2.16,3.63-.25,4.34,3.3-.22,1.04-4.04,1.51-6.11.1-.03.21-.06.31-.09Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m255.39,345.26l.63.03c.1.67.2,1.35.29,2.02-4.89,5.46,5.9,6.15,1.58,0,.1-.61.21-1.21.31-1.82.51.32,1.02.64,1.54.95.55.87.83,1.81.99,2.81-1.91,7.81-7.91,4.53-7.57-2.24.61-.42,1.6-1.16,2.23-1.76Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m311.7,251.81c-1.63,1.96-6.38-.56-3.79-2.56.33.85.57,1.83,1.28,2.45.84.04,1.67.07,2.51.11Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m302.4,231c-2.51.97-1.2-1.26-1.34-2.76.21-.02.41,0,.62.02.51.69.49,1.84.72,2.73Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m303.53,234.83c-.46-.04-.92-.07-1.38-.11.17-.81.33-1.62.5-2.43.3.84.59,1.69.89,2.53Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m267.28,345.54c0,.6,0,1.21,0,1.81-.42-.01-.84-.03-1.26-.04v-2.08c.21-.03.42-.07.63-.1.21.14.42.28.63.42Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m299.81,226.67c.12-.89.24-1.79.36-2.68.29.89.58,1.79.87,2.68-.41,0-.82,0-1.22,0Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m299.81,226.67c.41,0,.82,0,1.22,0,.14.42.27.84.41,1.26-.05.09-.07.19-.03.29-1.19.2-1.64-.56-1.6-1.56Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m332.76,258.99c-1.24-.71-.89-1.51-.13-2.34.04.78.09,1.56.13,2.34Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m304.53,238.58c-1.56-.16-1.68-.56-.64-2.2.21.73.43,1.47.64,2.2Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m299.46,221.97c-1.45-.38-1.54-.68-.57-1.9l.57,1.9Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m316.08,252.12c-.96.93-1.8.83-2.5-.3.83.1,1.67.2,2.5.3Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m305.71,242.35c-1.25-.34-1.38-.71-.55-1.58.09.02.18.03.27.03,0,0-.01-.01-.01-.01.1.16.2.31.3.47,0,.36,0,.73,0,1.09Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m307.28,247.05c-.35-.03-.7-.07-1.15-.11.22-.56.4-1.02.57-1.48.19.53.38,1.06.57,1.59Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m268.88,168.99c-.21.32-.43.63-.64.95.11-.43.21-.85.32-1.28.11.11.21.22.32.33Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m266.66,172.77c.28-.43.57-.85.85-1.28-.28.43-.57.85-.85,1.28Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m297.91,217.91c-.31-.1-.61-.21-.92-.31.29.02.59.04.88.06,0,0,0,0,0,0,0,.08.02.16.04.24Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m302.59,231.68c-.07-.23-.14-.45-.21-.68.07.23.14.45.21.68Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m266.33,173.05c.11-.1.23-.19.34-.29-.11.1-.23.19-.34.29Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m298.2,218.2c-.09-.09-.18-.19-.27-.28.09.09.18.19.27.28Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m317.04,252.38c-.11-.07-.21-.14-.32-.22.11.07.21.14.32.22Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m307.88,248.92c-.08-.11-.16-.22-.24-.33.08.11.16.22.24.33Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m218.48,207.6c-.02.19-.05.39-.07.58-1.55-.17-1.31,1.34-1.65,2.05-.63,1.32-1.31,2.82-.43,4.37-.53,1.73-1.06,3.46-1.59,5.19-.43.31-.86.62-1.28.93-.04-.32-.19-.86-.09-.92,1.13-.61,1.07-1.59,1.18-2.7.73-3.41.73-9.9,3.92-11.44,0,.64.01,1.29.02,1.93Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m214.11,229.89c-.65,1.16-1.36,2.27-2.05,3.41-2.32.1-1.26,2.03-1.97,3.25-.79-.24-1.57-.47-2.14-1.1,1.98-1.12,3.05-2.71,4.02-4.65.21-.29-.17-1.02-.2-1.15,1.08-1.1,2.01-2.04,2.94-2.98.21.32.43.63.64.95-.33.62-.54,1.32-.97,1.88-.09.13-.18.26-.27.39Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m199.45,272.11c3.23-.03,7.46-1.47,8.49,2.74-1.97-.22-2.76-2.22-4.75-1.91-1.31-.01-4.09.89-4.44-.8.23,0,.46-.02.7-.03Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m211.64,257.42c-.44.73-.8,1.51-1.29,2.2,0,0,.02-.01.02-.01-2.27.64-3.05,2.98-4.41,4.68-.44-.32-.87-.65-1.26-.93.11-.28.15-.46.19-.45,3.28,0,2.83-3.72,5.69-5.13.13-.98-1.1-2.54.71-3.51-.12,1.08-.97,2.25.37,3.16Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m213.4,205.36c1-1.89,1.14-4.07,1.91-5.99,0,0-.02.02-.02.02.22-.2.44-.41.67-.61,3.02,2.2-1.96,1.97-.4,4.46,1.18,2.12-.97,1.41-2.08,2.43-.03-.1-.06-.21-.08-.31Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m206.6,227.63c.57-1.49.97-3.05,1.85-4.4,3.7,1.29-2.61,2.39,0,6.46-.87.16-1.66.3-2.44.44.17-.84.36-1.67.59-2.5Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m218.72,218.23c.08-2.11.16-4.22.24-6.33.34-.21.68-.43,1.02-.64-.21-.3-.42-.6-.63-.9.04-.3.08-.6.13-.91.81,1.02,2.2,1.98.23,3.25.59,1.58-.02,3.73-.3,5.51-.23,0-.45.01-.68.02Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m294.2,235.5c.6-.86,1.19-1.71,1.79-2.57.32.18.65.35.97.53-.27.53-1,1.08-1.16,1.57.07.94-.58,1.19-1.15,1.72-.79.75-1.2,1.9-1.77,2.88-.18-.04-.36-.08-.53-.12,0-.41,0-.81-.01-1.22.13-.25.58-.45.47-.73.55-.62.94-1.37,1.4-2.06Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m213.42,245.25c-2.41-2.4.72-4.94,1.87-7.15-.33,1.01.44,2.43-1.27,3.02,1.33,1.62.23,2.85-.6,4.13Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m222.31,193.41c.76,1.55.65,3.37.85,5.05-2.74-2.23.85-2.65-4.45-6.71.61-.32,1.27-.22,1.93-.19.02.07.03.15.03.22.54.54,1.09,1.08,1.63,1.63Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m205.95,264.29c1.36-1.7,2.14-4.04,4.41-4.68-1.36,2.2-2.72,4.41-4.08,6.61-.11-.64-.22-1.29-.33-1.93Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m207.12,245.8l1.95,3.79c-1.14.69-1.79-.07-2.17-.91-.61-1.35-2.2-2.6-.7-4.3.03-.03.24.11.37.17.18.42.36.84.54,1.25Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m224.69,212.55c-.21,1.57-.43,3.14-.64,4.72-.19-.31-.38-.63-.57-.94-.49-3.18.7-5.62,1.85-8.45,0,0,.13-.04.13-.04.31,1.02.22,2.25-.34,3.15.07.57-.18,1.06-.42,1.56Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m199.99,268.68c-.76.81-1.12,1.73-1.24,2.82-1.97-1.06-.7-6.28,1.9-4.66-.92.71-1.92.88-.66,1.84Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m249.18,205.36c-.12.22-.24.44-.35.65-.14-1.93-1.9-5.74,1.24-5.98-.12,1.37-.25,2.75-.58,4.09l-.11-.03c-.09.42-.33.83-.21,1.26Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m250.38,198.79c0,.1-.02.2-.06.3-1-1.77-.91-3.55.06-5.33.34-.07.68-.14,1.02-.21.09,1.46-.4,2.87-.65,4.3,0,0-.1-.02-.1-.02-.08.32-.17.64-.25.97Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m195.67,264.93c.28-1.51.63-2.99,1.25-4.4,3.33.8-.22,3.15-1.25,4.4Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m209.73,237.03c-.24.83-.48,1.66-.72,2.5-2.25.1-1.32,1.8-1.26,3.76-3.12-1.62.29-4.88,1.98-6.26Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m232.5,237.96c-.4,1.89-.8,3.78-1.2,5.67-.71-1.52-.16-3.38-.32-5.04.51-.21,1.01-.42,1.52-.63Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m286.56,239.49c.34,1.63.34,3.34.59,5.01-2.23.78-1.73-4.25-.59-5.01Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m292.29,245.51c.33.72.66,1.43,1,2.15-2.17.14-2.67-1.47-3.17-3.07.42-.02.84-.04,1.26-.05.31.32.61.65.92.97Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m170.59,286.6c1.36.1,2.72.19,4.08.29-.36.4-.89,1.19-1.07,1.12-1.02-.41-2.64.36-3.01-1.41Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m209.75,277.94c.54,1.08,1.08,2.16,1.62,3.25-3.03.9-2.08-1.32-1.62-3.25Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m259.76,262.4c1.34-.57,2.69-1.12,4.03-1.69,0,1.13-3.84,3.99-4.03,1.69Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m230.39,247.69c-.22-.84-.44-1.68-.66-2.52.55-.31,1.06-.69,1.63-.96.04,1.25-.3,2.42-.97,3.48Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m193.74,273.39c2.4.53-.58,2.96-1.63,3.43.15-.72.29-1.45.44-2.17.89.06,1.25-.4,1.19-1.25Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m201.29,245.18c.27-.53.53-1.07.8-1.6.48.68.97,1.35,1.63,2.29-1.05.23-1.8.39-2.55.55.04-.41.08-.83.12-1.24Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m211.64,257.42c-1.34-.91-.49-2.08-.37-3.16.12-.14.24-.27.36-.41,1.24,1.18,1.11,2.37.02,3.57Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m225.29,274.01c-.43,1.36-1.18,2.73.07,4.07-1.86.21-1.29-1.39-1.52-2.24-.29-1.03.21-1.83,1.45-1.83Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m202.25,242.36c.13-.38.25-.76.3-1.16.08-.03.16-.07.24-.11l.29-1.11-.04-.07.05-.07c.42.61.85,1.22,1.27,1.83-.62.33-1.24.66-1.86.99-.08-.1-.17-.2-.25-.31Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m205.27,232c.1-.11.21-.22.31-.33.59.41,1.19.82,1.78,1.23-.08.16-.15.33-.23.49-.74.15-1.47.31-2.21.46-.01-.64.08-1.26.34-1.85Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m251.31,266.17c1.14-.53,2.29-1.06,3.43-1.6-.38,1.46-2.41,2.41-3.43,1.6Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m230.11,249.25c-.24.94-.49,1.88-.73,2.82-1.2-1.39,1.05-1.7-.98-3.38.09-.12.19-.25.28-.37.46.21.92.42,1.37.64-.02.1,0,.2.05.29Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m212.6,266.18c.8-1.28,1.6-2.56,2.39-3.85.46,1.67-.4,3.04-2.39,3.85Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m212.47,207.86c.23-.42.46-.83.69-1.25.51.47,1.03.94,1.55,1.41-.93.52-1.73.96-2.53,1.4.1-.52.19-1.04.29-1.56Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m267.59,259.26c.52-.2,1.04-.4,1.56-.6-.36,1.26-2.21,3.23-2.82,1.03.43-.11.84-.27,1.26-.42Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m228.88,256.13l-.14.94c-.37.49-.99.65-1.51.96-.24-1.86.2-2.36,1.64-2.52,0,.21,0,.41,0,.62Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m218.48,207.6c0-.64-.01-1.29-.02-1.93.52.1,1.05.21,1.57.31.06.74-.16,1.46-.27,2.18-.07-.42-.13-.83-.2-1.25-.25-.2-.5-.41-.75-.61-.11.43-.22.86-.33,1.29Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m302.61,251.71c.02-.4.04-.8.07-1.21.54.28,1.57-.9,1.68.38.08.96-.79,1.3-1.72,1.19l-.02-.36Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m198.5,255.2c-.04-.1-.07-.21-.11-.31.11-.42.21-.84.32-1.27l.12.02c.07-.12.15-.23.22-.35,0,0-.01,0-.01,0,.72.04,1.02.43,1.98.85-1.12.46-1.82.75-2.52,1.04Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m216.16,236.6c.23-.43.46-.86.68-1.29,1.02.68,1.35,1.29,1.51,2.6-.99-.59-1.59-.95-2.2-1.31Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m213.46,220.72c.43-.31.86-.62,1.28-.93-.24,1.14-.47,2.28-.71,3.43-.21-.83-.64-1.63-.57-2.5Z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m223.23,254.88c-.44-.12-.88-.24-1.32-.36-.05-.54-.1-1.08-.15-1.63,1.48.23,1.94.87,1.47,1.98Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m248.76,206.61c-.1.63-.21,1.25-.31,1.88-.39-.34-.79-.68-1.18-1.02.5-.29.99-.58,1.49-.86Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m200.58,248c.02-.21.05-.41.07-.62.08-.01.16-.02.24-.03.47.49.94.98,1.41,1.46-.1.12-.2.24-.3.36-.54-.08-1.07-.16-1.61-.24-.04-.1-.08-.21-.12-.31.04-.09.06-.18.06-.28.09-.11.17-.23.26-.34Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m231.25,244.25c-.51.31-1.01.62-1.52.92-.85-1.46.3-1.77,1.25-2.19.11.22.21.43.32.65-.02.21-.04.41-.05.62Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m242.81,221.22c.03-.16.06-.32.1-.48.09-.02.17-.04.26-.06.52.36,1.03.72,1.89,1.32-1.55.71-1.82.65-2.24-.78Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m227.22,258.02c.4-.21.8-.42,1.2-.63.19.42.14.83.1,1.25-.24.54-.48,1.08-.64,1.66-.22-.76-.44-1.52-.67-2.28Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m248.76,221.97c-.37.74-.74,1.49-1.11,2.23-.75-1.52-.56-1.89,1.11-2.23Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m216.26,195.6c.11-.3.22-.6.33-.9.42-.1.83-.21,1.25-.31.06.44.11.88.2,1.57-.62,0-1.19,0-1.76,0,0,0,0,0,0,0,0-.12,0-.23-.01-.35Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m208.81,220.72c.11-.52.21-1.04.32-1.56.55.44,1.1.87,1.65,1.31-.08.13-.16.26-.23.39-.58-.05-1.16-.09-1.74-.14Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m194.75,267.74c.29-.63.34-1.42.88-1.88.4.11.79.22,1.62.45-1.1.63-1.79,1.03-2.49,1.43Z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m213.46,221.34c.29.95.55,1.91.96,2.81-.42-.19-.84-.37-1.26-.56.34-.72-1.16-1.68.29-2.25Z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m178.73,286.92c.73-.1,1.46-.21,2.19-.31-.84.78-1.25,1.71-2.19.31Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m281.34,254.93c.51-.18,1.01-.36,1.52-.54,0,.53,0,1.06,0,1.6-.16.09-.31.18-.47.27-.35-.44-.7-.89-1.05-1.33Z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m326.51,258.19h-3.01c0-.1,0-.21,0-.31h3.01c0,.1,0,.21,0,.31Z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m232.5,237.96c-.51.21-1.01.42-1.52.63-.58-1.29.44-1.52,1.25-1.88.09.41.41.83.27,1.25Z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m281.41,242.36c-.09-.32-.19-.63-.28-.95.08,0,.16,0,.23,0,1.5,1.01,1.55,1.42.26,2.22-.06-.32-.12-.65-.19-.97.16-.09.03-.18-.02-.3Z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m283.54,250.81l.89.86c-.4.24-.8.47-1.21.71-.09-.1-.18-.21-.26-.31-.05-.41-.13-.83-.05-1.24.21,0,.42,0,.63-.01Z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m232.86,233.57c-1.7-.24-.64-1.48-.7-2.43.23.18.47.37.7.55v1.88Z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m248.76,210.06l.38,1.85c-.28.02-.57.05-.85.07.16-.64.31-1.28.47-1.92Z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m215.35,227.62c-.21-.32-.43-.63-.64-.95.16-.44.32-.88.48-1.33.06.76.11,1.51.17,2.27Z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m193.71,271.17l.09-.6c.3-.31.59-.63.89-.94.43.37.85.73,1.53,1.31-1.09.1-1.8.16-2.5.23Z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m308.26,258.07c-.83,0-1.67,0-2.5,0,.8-1.27,1.58-1.27,2.5,0Z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m296.42,230.44c-.03-.11-.07-.21-.1-.32.04-.09.05-.19.03-.29.51.31,1.02.63,1.53.94-.37.2-.75.41-1.12.61-.03-.35-.08-.68-.33-.93Z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m190.93,282.16c.44.38.88.77,1.32,1.15l-.38.54c-.52-.25-1.04-.5-1.57-.75.21-.31.42-.63.63-.94Z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m232.86,233.57v-1.88c.34,0,.68.02,1.02.03-.16.72-.32,1.44-.47,2.15-.18-.1-.36-.2-.54-.3Z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m275.07,256.67c.43-.2.83-.48,1.29-.59.07.03.21.04.28.02,0,.33.01.66.02.99-.69.47-1.41,1.05-1.59-.42Z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m185.92,286.61c.52,0,1.04,0,1.57,0-.29.39-.57.77-.86,1.16-.24-.39-.47-.77-.71-1.16Z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m165.57,292.2c-.24-.4-.48-.81-.72-1.21,1.14-.1,1.83.29,1.66,1.58-.1-.03-.2-.04-.3-.01-.21-.12-.43-.23-.64-.35Z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m224.72,209.75c-.42.73-.83,1.46-1.25,2.19-.75-1.4.25-1.8,1.25-2.19Z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m228.79,231.38c.25.53.5,1.07.75,1.6-.2.11-.4.23-.6.34-.26-.33-.51-.67-.77-1,.21-.31.41-.63.62-.94Z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m197.57,258.34c-.02-.2-.03-.41-.05-.61,0,0,0,0,0,0,.25-.29.38-.64.54-.99.23.22.47.43.7.65-.1.31-.21.63-.31.94-.29,0-.58,0-.87,0Z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m217.84,194.38c-.42.1-.83.21-1.25.31.01-.28.03-.56.04-.84.3-.35.59-.7.89-1.05.11.53.21,1.05.32,1.58Z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m211.89,281.54c.73-.08,1.45-.16,2.18-.24q-.75,1.58-2.18.24Z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m281.11,240.47c0-.21-.02-.42-.03-.63.19-.21.39-.42.58-.63.37.05.74.09,1.12.14.04.15.08.3.12.45-.6.22-1.19.44-1.79.67Z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m223.73,201.59c.04.09.06.18.06.28.41.42.39,1.04.33,1.59-1.22-.36-1.33-.88-.39-1.87Z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m189.58,288.05c.38-.53.77-1.05,1.15-1.58.16.12.33.24.49.36l-1.14,1.52c-.17-.1-.33-.2-.5-.3Z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m283.54,250.81c-.28,0-.56.02-.84,0-.31-.61-.44-1.22-.34-1.9.06.02.18.03.24.02.31.63.63,1.25.94,1.88Z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m294.55,224.8c-.58-.77-.12-1.42.26-2.2,1.57.93-.09,1.48-.26,2.2Z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m242.77,208.49c.15-.73.31-1.46.46-2.19.53,1.19.33,2.62-.31,3.74-.19-.5-.17-1.03-.15-1.55Z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m319.32,257.38c-.51-.14-1.03-.28-1.54-.42l.09-.47c.54.06,1.08.13,1.62.19-.05.23-.11.46-.16.7Z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m218.72,218.23c.33,0,.66-.03.99-.02v1.57c-.22,0-.44,0-.66.01-.11-.52-.22-1.04-.33-1.56Z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m232.55,237.66c-.21-.82-.97-2.49.58-2.52-.19.84-.38,1.68-.58,2.52Z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m250.38,193.76c-.21.52-.42,1.05-.63,1.57-.2-.34-.4-.68-.6-1.01.41-.18.82-.37,1.23-.55Z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m294.81,222.6c-.19.41-.38.83-.57,1.24-.21-.73-.41-1.46-.62-2.19.4.32.79.63,1.19.95Z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m225.91,269.94c-.11.52-.21,1.05-.32,1.57-.28-.29-.55-.58-.83-.87.38-.23.76-.47,1.15-.7Z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m199.83,250.55c.08-.12.15-.24.23-.36.88.93.77,1.22-.62,1.57.09-.31.17-.63.26-.94.09-.06.14-.15.14-.26Z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m248.81,267.42c.42-.21.83-.42,1.25-.62-.13.4-.27.8-.4,1.19-.28-.19-.57-.38-.85-.57Z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m244.12,212.57c.28,0,.57,0,.85-.01-.18.53-.35,1.05-.53,1.58-.11-.52-.21-1.05-.32-1.57Z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m194.68,269.62c-.3.31-.59.63-.89.94-.05-.75.45-1.46.63-2.18.09.41.17.83.26,1.24Z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m218.14,232.93c.63-.19,1.26-.37,1.89-.56-.25,1.48-1.26.37-1.89.56Z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m219.71,219.78v-1.57c.28.3.57.6.85.9-.28.22-.57.44-.85.67Z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m216.12,284.26c-.07.41-.15.83-.22,1.24-.12-.01-.25-.02-.37-.03v-1.31c.2.03.39.07.59.1Z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m293.54,218.51c.11-.21.22-.42.32-.63.42-.08.84-.17,1.26-.25.02,1.28-.94.78-1.58.88Z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m243.49,208.8v-1.88c.17.63,1.07,1.25,0,1.88Z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m192.55,274.64c.12-.41.23-.81.35-1.22.28-.06.56-.04.85-.04.06.85-.3,1.31-1.19,1.25Z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m294.21,249.18c.29.55.57,1.09.86,1.64-1.67.19-1.01-.86-.86-1.64Z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m281.93,246.73c.04-.1.07-.2.11-.31.93.25,1.17.76.57,1.57-.08,0-.17,0-.25,0-.14-.42-.28-.84-.42-1.26Z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m227.24,223.22c.24.19.48.39.72.58-.61.37-1.06.39-1.56-.16.28-.14.56-.28.84-.42Z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m198.44,258.34c.1-.31.21-.63.31-.94.26.27.53.55.79.82-.37.04-.74.08-1.1.12Z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m208.45,223.23c-.23.41-.47.82-.7,1.23.15-.72.3-1.44.44-2.16.09.31.17.62.26.93Z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m295.5,227.6c-.11-.52-.22-1.04-.33-1.55.19,0,.38,0,.58,0l.63.63c-.29.31-.58.62-.87.93Z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m299.81,246.42c-.06-.37-.12-.74-.19-1.11.11-.05.22-.1.33-.16.26.42.53.84.79,1.27h-.94Z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m287.3,244.57c.52,0,1.04.02,1.56.03-.55,1.55-1.05.62-1.56-.03Z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m218.09,253.46c-.24-.45-.48-.9-.72-1.35.4,0,.8,0,1.41,0-.29.57-.49.96-.69,1.35Z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m198.75,271.5c.11-.53.22-1.07.33-1.6.12.73.25,1.47.37,2.2-.23,0-.46.02-.7.03,0-.21,0-.42,0-.63Z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m223.18,259.98c.18-.5.05-1.14.79-.79-.08.32-.17.63-.25.95-.18-.05-.36-.11-.54-.16Z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m281.67,239.21c-.19.21-.39.42-.58.63-.02-.69-.34-1.47.22-2.02.12.46.24.93.36,1.39Z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m228.79,231.38c-.21.31-.41.63-.62.94,0-.53.1-1.05.14-1.57.16.21.32.42.48.63Z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m295.5,227.6c.29-.31.58-.62.87-.93-.22.42-.44.84-.66,1.27-.09,0-.18-.02-.27-.04-.02-.11,0-.2.06-.3Z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m244.12,212.57c.11.52.21,1.05.32,1.57-.08.1-.17.2-.25.3-.11-.62-.52-1.25-.37-1.87.1,0,.2,0,.3,0Z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m215.96,198.77c-.22.2-.44.41-.67.61.14-.72.29-1.44.43-2.16.08.52.16,1.03.24,1.55Z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m216.27,280.94c.2-.14.4-.27.59-.41.11.35.23.71.34,1.06-.12.07-.24.14-.35.22-.19-.29-.39-.57-.58-.86Z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m276.66,257.08c.01-.41-.07-.84.03-1.25.21-.02.41-.04.62-.06-.08.22,0,.45-.02.68-.21.21-.42.42-.63.63Z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m299.81,246.42h.94c.1.19.21.39.31.58-.42,0-.83,0-1.25,0,0-.19,0-.38,0-.58Z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m298.88,247c-.51.01-1.01.02-1.52.04-.04-.08-.07-.17-.09-.26l.04-.05c.52.09,1.04.18,1.56.27Z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m190.93,282.16c-.21.31-.42.63-.63.94-.06,0-.2,0-.26,0-.14-.43.23-.84.33-1.25.06,0,.18,0,.24,0,.1.1.21.21.31.31Z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m295.14,251.07c.31.33.62.66.94.99-1.31.61-.87-.43-.94-.99Z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m207.12,245.8c-.18-.42-.36-.84-.54-1.25.22,0,.43,0,.65,0-.04.41-.07.83-.11,1.24Z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m211.34,212.25c.18-.54.35-1.08.53-1.63-.18.54-.35,1.08-.53,1.63Z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m282.92,254.26c.09-.32.18-.63.27-.95.17.07.34.15.51.22-.26.24-.52.49-.78.73Z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m226.85,266.8c.11.2.21.39.32.59-.21.11-.42.22-.63.33.1-.31.21-.61.31-.92Z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m222.54,258.39c.13-.54.26-1.08.39-1.62.07,0,.15,0,.23,0,0,0,.01.01.01.01,0,.31,0,.62,0,.93-.21.23-.41.45-.62.68Z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m239.11,272.15c.3-.13.61-.27.91-.4-.16.29-.31.59-.47.88l-.45-.48Z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m277.29,256.46c0-.19-.01-.38-.02-.57.32-.1.64-.21.96-.31-.31.29-.63.59-.94.88Z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m223.47,215.39v.94c-.19-.18-.38-.36-.57-.55.19-.13.38-.26.57-.4Z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m203.96,236.67c.06-.4.12-.8.18-1.2.16.43,1.07.98-.18,1.2Z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m285.73,260.48c-.21,0-.42,0-.63,0,.11-.25.23-.5.34-.75.1.16.19.33.29.49,0,.09,0,.18,0,.26Z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m288.55,260.16l-.31.11c-.21-.04-.42-.08-.63-.13.31-.18.63-.37.94-.55,0,.19,0,.38,0,.57Z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m220.04,206.61c0-.21,0-.42,0-.63.27.05.53.1.8.15l.03.25c-.27.08-.55.16-.82.23Z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m223.16,257.71c0-.31,0-.62,0-.93.19.13.38.26.56.39l-.57.54Z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m245.39,193.09c.3-.21.61-.41.91-.62-.21.22-.43.45-.64.67-.09-.01-.18-.03-.27-.05Z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m314.26,256.46c.17.08.29.14.41.2-.21.55-.91.29-.41-.2Z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m257.27,263.36c.52-.19,1.03-.38,1.55-.57-.52.19-1.03.38-1.55.57Z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m227.17,263.35c-.08.32-.16.63-.24.95.08-.32.16-.63.24-.95Z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m230.34,275.89c.31-.11.62-.23.93-.34-.31.11-.62.23-.93.34Z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m245.31,195.93c.08-.49.15-.98.23-1.48.05-.02.11-.04.16-.05-.13.51-.26,1.02-.39,1.53Z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m293.27,219.77c.09-.42.18-.84.27-1.26-.09.42-.18.84-.27,1.26Z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m273.23,257.2c.2-.05.4-.1.6-.14-.05.27-.09.55-.21,1.26-.22-.64-.31-.88-.39-1.11Z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m244.05,202.2c.12-.54.23-1.08.35-1.63-.12.54-.23,1.08-.35,1.63Z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m235.67,231.36c-.31.09-.62.19-.94.28.31-.09.62-.19.94-.28Z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m246.58,268.66c.21-.1.42-.21.63-.31.06.15.12.31.19.46-.27-.05-.54-.1-.81-.15Z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m203.01,264.21c-.06.27-.15.3-.37.15.06-.27.15-.3.37-.15Z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m302.32,248.93c-.15-.16.03-.42.01-.63.16.08.32.16.48.25-.16.13-.33.25-.49.38Z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m282.03,245.8c-.02-.21-.03-.42-.05-.63.17.12.33.24.5.36-.15.09-.3.18-.45.26Z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m302.61,251.71c0,.12.01.24.02.36-.21-.09-.42-.18-.63-.26.2-.03.4-.07.61-.1Z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m211.35,268.67c.18-.31.36-.62.54-.93-.18.31-.36.62-.54.93Z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m295.75,226.05c-.19,0-.38,0-.58,0-.07-.08-.09-.17-.07-.28.21.09.43.18.64.28Z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m226.48,261.08c-.06.27-.15.3-.37.15.06-.27.15-.3.37-.15Z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m225.59,273.07c-.08.21-.16.42-.24.63.08-.21.16-.42.24-.63Z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m328.9,260.82c-.21.09-.41.17-.62.26.21-.09.41-.17.62-.26Z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m288.55,260.16c0-.19,0-.38,0-.57.2.09.41.19.61.28-.2.1-.41.19-.61.29Z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m205.55,236.83c.27.06.3.15.15.38-.27-.06-.3-.15-.15-.38Z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m312.64,258.59c-.2-.11-.4-.22-.59-.33.2.11.4.22.59.33Z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m200.2,288.67c-.06.27-.15.3-.37.15.06-.27.15-.3.37-.15Z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m211.66,217.16c-.27-.06-.3-.15-.15-.37.27.06.3.15.15.37Z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m190.64,292.57l-.65.2.65-.2Z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m244.04,218.5c.05-.41.1-.81.15-1.22-.05.41-.1.81-.15,1.22Z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m195.63,265.86c-.1.1-.21.21-.31.31.01-.27.02-.54.03-.81.09-.04.18-.09.27-.14,0,.21,0,.43,0,.64Z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m250.41,192.33c.16.15.31.31.47.46-.16-.15-.31-.31-.47-.46Z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m302.33,248.3c-.02.14-.03.29-.05.43-.1-.35-.21-.7-.31-1.04.12.2.24.41.36.61Z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m315.13,258.59c-.31.04-.62.14-.91-.02.3,0,.61.01.91.02Z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m192.47,292.41c-.3.01-.6.03-.91.04.3-.01.6-.03.91-.04Z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m282.35,247.99c.08,0,.17,0,.25,0,0,.31,0,.63,0,.94-.11.01-.25-.04-.36.02,0-.32-.03-.65.1-.96Z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m169.97,293.09c-.31,0-.62-.01-.93-.02.31,0,.62.01.93.02Z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m255.46,263.99c.19-.08.37-.17.56-.25-.19.08-.37.17-.56.25Z"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m209.41,289.07c-.32.1-.64.2-.96.3.32-.1.64-.2.96-.3Z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m283.54,236.34c.22.12.44.24.65.36-.32-.08-.63-.15-.95-.23.1-.04.2-.09.29-.13Z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m211.02,269.93c.07-.33.15-.67.22-1-.07.33-.15.67-.22,1Z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m202.25,242.36c.08.1.17.2.25.31-.11.21-.21.42-.32.63.02-.31.04-.62.06-.93Z"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m225.02,219.82c.09.3.19.59.28.89-.09-.3-.19-.59-.28-.89Z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m210.34,215.7c-.02-.1-.04-.21-.07-.31.12-.21.25-.42.37-.62-.1.31-.2.62-.3.94Z"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m244.13,227.93c-.21.17-.42.35-.63.52.21-.17.42-.35.63-.52Z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m210.64,214.76c.1-.32.21-.63.31-.95-.1.32-.21.63-.31.95Z"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m225.04,206.58c.08.32.16.64.24.95-.08-.32-.16-.64-.24-.95Z"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m193.39,272.12c.11-.32.22-.64.33-.97-.11.32-.22.64-.33.97Z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m280.74,261.48c-.03.08-.04.16-.04.24-.31.06-.61.13-.92.13,0,0,.04-.11.04-.11.31-.08.62-.17.93-.25Z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m215.91,196.88c.04-.31.08-.62.12-.93.08,0,.16,0,.24,0,0,0,0,0,0,0-.12.31-.24.62-.37.92Z"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m188.73,286.24c.21-.22.41-.44.62-.66-.21.22-.41.44-.62.66Z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m223.21,256.13c.01-.3.02-.61.04-.91-.01.3-.02.61-.04.91Z"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m245.7,194.39c.01-.32.03-.64.04-.95-.01.32-.03.64-.04.95Z"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m196.9,291.58c-.32.08-.64.17-.95.25.32-.08.64-.17.95-.25Z"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m203.16,239.52c0-.2.02-.41.02-.61,0,.2-.02.41-.02.61Z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m217.77,233.55c.12-.21.24-.41.37-.62-.12.21-.24.41-.37.62Z"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m208.39,221.96c.11-.25.22-.5.33-.76-.11.25-.22.5-.33.76Z"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m285.73,260.48c0-.09,0-.18,0-.26.2.07.4.15.61.22-.2.01-.4.03-.61.04Z"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m191.53,278.39c.11-.22.22-.43.33-.65-.11.22-.22.43-.33.65Z"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m227.84,260.53c.03.1.06.21.09.31-.13.11-.25.23-.38.34.1-.22.2-.43.29-.65Z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m293.3,221.02c0-.2,0-.4,0-.61,0,.2,0,.4,0,.61Z"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m211.95,210.36c0-.2,0-.4,0-.6,0,.2,0,.4,0,.6Z"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m320.14,259.24c-.2,0-.41,0-.61-.01.2,0,.41,0,.61.01Z"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m281.35,241.4c-.08,0-.16,0-.23,0,0-.21.01-.42.02-.63.07.21.14.42.22.63Z"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m236.62,231.31c-.21.02-.42.03-.63.05.21-.02.42-.03.63-.05Z"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m223.65,199.62c-.01.12-.02.24-.04.37-.06-.18-.11-.35-.17-.53.07.06.13.11.2.16Z"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m218.18,286.56c-.22.08-.44.16-.67.25.22-.08.44-.16.67-.25Z"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m199.38,253.32c-.11,0-.22,0-.34-.01.03-.2.06-.4.08-.6.08.2.17.41.25.61Z"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m250.31,200.03l-.25.63c0-.21,0-.42,0-.63.08,0,.16,0,.25,0Z"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m282.97,252.07c.09.1.18.21.26.31,0,.11,0,.23-.01.34-.12-.12-.23-.23-.35-.35.03-.1.07-.21.1-.31Z"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m205.4,290.03c-.03.09-.05.18-.09.27-.2-.01-.41-.03-.61-.04.23-.08.46-.15.69-.23Z"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m212.26,267.12c.09-.2.18-.39.28-.59-.09.2-.18.39-.28.59Z"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m243.56,204.72c-.03-.1-.07-.2-.1-.3.03-.1.07-.2.1-.3,0,.2,0,.4,0,.6Z"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m202.45,290.92c-.18-.02-.37-.03-.55-.05.23-.07.46-.13.7-.2-.04.09-.09.17-.14.25Z"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m189.06,292.73c-.21.02-.42.03-.63.05.21-.02.42-.03.63-.05Z"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m294.19,258.89c-.21.04-.42.08-.62.12.21-.04.42-.08.62-.12Z"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m250.06,266.8c.1-.08.2-.15.3-.23-.1.08-.2.15-.3.23Z"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m296.36,229.84l-.24-.34.24.34Z"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m281.34,261.39l-.14.06-.15-.03c.1,0,.2-.02.3-.03Z"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m239.68,224.46c.12-.09.24-.19.37-.28-.12.09-.24.19-.37.28Z"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m331.09,260.53c-.08.04-.17.08-.25.12.07-.06.16-.1.25-.12Z"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m207.9,274.86c.1.13.19.26.29.39-.1-.13-.19-.26-.29-.39Z"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m231.26,275.56c.11-.08.23-.17.34-.25-.11.08-.23.17-.34.25Z"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m191.32,278.73c.07-.12.15-.23.22-.35-.07.12-.15.23-.22.35Z"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m190.95,279.66c.09-.02.18-.04.27-.06-.08.12-.16.24-.24.36-.05-.09-.06-.19-.03-.3Z"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m241.98,222.29c.09-.1.17-.2.26-.3-.09.1-.17.2-.26.3Z"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m190.34,281.55c.09,0,.18-.02.27-.04,0,.11,0,.23,0,.34-.06,0-.18,0-.24,0-.06-.09-.07-.19-.03-.3Z"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m225.67,221.31c.08.11.17.23.25.34-.08-.11-.17-.23-.25-.34Z"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m327.03,260.48l-.31.09c-.07-.08-.15-.16-.22-.24.18.05.36.1.54.16Z"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m325.15,260.17c-.17-.06-.34-.13-.51-.19.17.06.34.13.51.19Z"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m224.72,219.49c.08.05.16.08.25.11,0,.06,0,.13-.02.19-.08-.1-.15-.2-.23-.3Z"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m200.3,291.18c-.07.05-.21.06-.3.03.1-.01.2-.02.3-.03Z"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m198.43,291.5c-.08.03-.22.03-.29,0,.1,0,.2,0,.29,0Z"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m199.15,291.29c-.13.08-.26.16-.39.23.13-.08.26-.16.39-.23Z"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m194.67,292.12c-.08.02-.22.02-.29-.01.1,0,.19,0,.29.01Z"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m185.29,293.06c-.19,0-.1,0,0,0-.08.03-.22.02,0,0Z"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m184.04,293.45c-.11-.07-.22-.14-.33-.21.12-.01.24-.03.36-.04-.01.08-.02.17-.03.25Z"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m215.93,237.01c.09-.13.18-.27.26-.4-.09.13-.18.27-.26.4Z"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m299.86,258.28c-.13.01-.25.02-.38.03.13-.01.25-.02.38-.03Z"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m248.19,191.28c.14.08.28.16.43.25-.14-.08-.29-.16-.43-.25Z"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m223.15,256.77c-.08,0-.15,0-.23,0,.07-.12.14-.24.21-.37,0,.12.01.24.02.36Z"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m219.08,254.52c-.11-.08-.22-.17-.33-.25.11.08.22.17.33.25Z"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m244.47,200.34c-.04-.11-.03-.21.04-.3.04.12.14.24-.04.3Z"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m207.52,243.29c.08,0,.16,0,.24,0-.06.15-.13.31-.19.46-.01-.15-.03-.31-.04-.46Z"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m224.75,205.88c.09.05.17.09.26.14-.03.08-.06.17-.08.25-.06-.13-.12-.26-.17-.4Z"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m200.14,249.85c.06-.1.11-.21.17-.31-.06.1-.11.21-.17.31Z"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m296.99,246.78c-.03-.11-.06-.22-.08-.33.14.09.27.18.41.27,0,0-.04.05-.04.05-.09,0-.19,0-.28,0Z"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m176.51,335.53c-3.3.04-6.6.04-9.89.13-.13-.08-.25-.16-.38-.24-.01-7.97-.02-15.95-.04-23.92,0-.68,0-1.28.92-1.22,7.37-.42,21.55-.78,16.58,10.44-.51.34-1.02.67-1.76,1.15,4.8,2.19,5.06,7.05,2.74,11.13-2.5,1.68-5.15,2.54-8.18,2.53Zm-2.78-8.04c-1.06,3.06,4.85,2.35,4.37.19.5-1.87-5.21-3.31-4.37-.19Zm.07-7.4c3.9-.6,3.8-3.63,0-4.34v4.34Z"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m251,335.83c-2.85-.6-5.94.13-8.76-.37,1.01-7.19.6-14.32.89-21.55-.08-1.06-1.34-1.42-2.09-1.97,0-.32.01-.63.02-.95.15-.06.07-.17.04-.28.06-.13.12-.25.18-.38,7.37-.16,18.29-1.23,20.4,7.89.08.11.17.22.25.33h-.01c1.18,3.17.59,6.91-.65,10.01-3.4-1.01-1.72,2.09-3.31,3.4-.96.33-.96.88-.7,1.63-1.85,1.3-4.14,1.57-6.27,2.23Zm-2.19-18.6c-.22-.61-.45-1.23-.67-1.84-.21.01-.43.03-.64.04-.32,1.07-.9,3.2.95,3.11.72,4.03-2.45,13.5,4.7,9.23-.18.84-.37,1.68-.57,2.61,2.28-.01,2.4-1.94,3.17-3.1.19-.29-.66-1.28-1.04-1.95.03-.18.05-.35.08-.53.96-.83.94-1.67,0-2.51-.17-3.43-2.56-5.74-5.98-5.07Z"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m203.4,335.56c-4.58-.06-9.17.11-13.74-.09-.09-.11-.19-.23-.28-.34.11-8.13-.83-16.91.31-24.74,2.35-.09,4.71-.11,7.06.04.57,5.45.02,11.06.18,16.56-.85,3.68,6.98,1.18,9.33,1.89-.46,2.72,1.63,8-2.86,6.67Z"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m236.43,328.85c-1.7,9.28-16.36,9.14-17.61-.56-.78-3.17,4.84-1.85,6.78-2.22.73.59.8,1.7,1.23,2.52,1.05.81,1.66.54,2.05-.91,0,0,.05.01.05.01.38-5.53-.21-11.15.12-16.69,2.28-1.07,4.81-.59,7.25-.65.39,6.12.69,12.42.13,18.5Z"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m216.67,312.57c-.05,7.62.06,15.24-.14,22.85-1.6.24-9.03,1.69-7.5-1.54,0-7.63-.11-15.26,0-22.89,2.28-1.07,4.81-.59,7.25-.65.13.74.26,1.48.39,2.23Z"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m233.75,351.77c-.2.64-.39,1.28-.59,1.92l-.68-.22c-.16-.88-.15-1.77-.14-2.66.04-1.51-.44-3.41.2-4.96.42-.01.84-.02,1.26-.04.74.7,1.16,1.44,1.81,2.34.82-.69,1.55-1.29,2.27-1.9,0,.36-.01.73-.02,1.09.71,0,1.42.02,2.13.03-.08,2.1-.17,4.2-.25,6.3-.51-.02-1.01-.04-1.52-.05-.14-1.32-.1-2.65-.1-3.97-.2-.15-.4-.31-.6-.46-.31.53-.62,1.05-.92,1.58-.4.11-.79.25-1.2.35-.48-.29-.97-.59-1.64-1,0,.67,0,1.16,0,1.65Z"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m256.95,294.02c2.19.4,3.07,2.8,2.88,4.77-.08.29.02.62-.04.93-.84.85-1.69,1.7-2.53,2.55-1.31-.02-2.62-.05-3.93-.07-.47-2.65-.06-5.54-.19-8.17h3.81Zm-1.82,6.88c3.2-.59,2.87-.74,2.71-3.82-.08-1.55-1.56-1.22-2.71-1.43v5.26Z"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m313.86,300.74c.24.42.48.84.73,1.26-1.44.68-2.19-.06-2.85-1.04-.06-1.01-.48-1.49-1.56-1.08v1.41l-.67.99c-2.13-.58-.51-6.16-.9-8.18,3.14-.57,7.27.89,4.97,4.06-1.8.48-.42,1.66.28,2.58Zm-4.05-5.22c.43,1.12.72,1.87,1.01,2.62,1.99-1.08,1.35-2.47-1.01-2.62Z"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m304.23,301.22c-2.07-2.16-3.02,1.45-4.98.98,1.18-2.5,1.85-5.2,2.75-7.81.32-.12.63-.24.95-.36,2.46,1.35,2.56,5.48,3.46,8.04-.12.11-.24.22-.36.33-.6-.39-1.21-.78-1.81-1.18Z"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m173.97,348.94c.33-.94.66-1.88.99-2.82.54-.3,1.08-.59,1.61-.89,0,0,0,0,0,0,.73-.01,1.41.3,2.15.28,0,0,0,0,0,0,2.57.95,2.48,3.96,1.92,6.26-1.64,2.78-5.06,2.34-6.58-.32-.03-.83-.05-1.67-.08-2.5Zm3.19-1.63c-2.5.52-1.55,4.7.56,4.56,1.31-1.07,2.87-3.79.39-4.55l-.18-1.09c-.1,0-.2,0-.3-.01-.15.37-.31.73-.46,1.1Z"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m276.63,302.22c-.45-.02-.89-.04-1.34-.05.15-2.61-.49-5.45.13-7.94.21-.03.41-.07.62-.1.72,1.11,1.24,2.2,1.09,3.55.54-.14,1.08-.28,1.62-.42-.28-.46-.55-.91-.83-1.37.1-.58.21-1.17.31-1.75.99.05,1.83.48,2.69.94.13,2.53-1.24,4.11-.51,6.53-.1.03-.2.07-.3.1-1.07-.59-2.14-1.19-3.36-1.86-.05,1.08-.08,1.73-.12,2.38Z"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m167.51,353.33c-2.28,1.84-1.24-6.66-.97-7.7,1.45-.19,2.93-.11,4.36.19.33.42.67.83,1,1.25,0,.31,0,.62,0,.93-2.7,3.29-.63,2.45-.36,5.69-.31-.02-.62-.04-.93-.05-.1-.11-.21-.22-.31-.34,0,0,.01,0,.01,0-.72-.98-1.12-2.29-2.79-2.74v2.76Zm1.5-6.22c-3.04-.78-1.24,3.92.96,1.1-.32-.37-.64-.73-.96-1.1Z"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m295.76,300.77c-.1-.04-.21-.07-.31-.11-.04-.07-.08-.14-.12-.21-1.02.74-2.24,1.21-3.33,1.84-.2-.02-.4-.05-.6-.07.52-1.97,1.08-3.93,1.57-5.91,0,0-.01,0-.01,0,.39-.46.42-1.09.61-1.64.49-.28.97-.56,1.48-.86,2.01,2.28,2.43,5.52,3.15,8.4-1.28.35-1.69-.78-2.43-1.44Zm-.68-3.62c-1.71,1.57-1.46,2.5.46,2.83-.16-1-.31-1.92-.46-2.83Z"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m229.1,353.69c-.17-.03-.34-.06-.51-.09-.34-.42-.68-.83-1.02-1.25,0,0,.01.02.01.02-.19-.12-.34-.37-.59-.35-.07-1.38-.14-2.75-.21-4.13-.17-.04-.35-.07-.52-.11-.81,1.31-.64,2.79-.65,4.27-.41.42-.83.83-1.21,1.28l-1.54.28c.53-2.05,1.03-4.13,1.58-6.16q1.33-1.99,3.61-1.25c-.01.09.01.17.08.24.44,2.12.98,4.21,1.57,6.29-.2.33-.4.66-.59.98Z"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m282.91,296.89c.85-2.36,2.93-3.16,5.26-2.41,0,0-.01-.03-.01-.03.23.08.4.3.64.32.01.5.03.99.04,1.49-1.4.04-2.85-1.16-3.78.58-1.49,3.19,1.44,4.26,3.79,4.79-1.52,1.16-3.53.66-5.04-.27-1.06-1.23-.69-2.95-.92-4.47Z"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m317.95,294c.53.04,1.08-.07,1.58.13.11.57.21,1.15.32,1.72-1.87-.1-1.09,2.07-1.32,3.25-.85-.15-1.49.14-1.85.95-.49-1.75-.29-3.55-.32-5.35.53-.23,1.07-.47,1.6-.7Z"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m288.87,301.62c-.63-.22-1.27-.44-1.9-.65-.07-1.16-.07-2.29-.97-3.13.96-.12,1.91-.24,2.87-.37.2,1.24.39,2.48.59,3.73-.19.14-.39.29-.58.43Z"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m247.25,349.89c.22-.37.45-.74.67-1.12.82-.34,1.17-.84.56-1.66.19-.55.17-1.21.65-1.59.78-.17,1.11,0,2.12.12-.43,1.2-.81,2.25-1.19,3.31h0c-.24.2-.36.45-.4.75-.26.17-.53.35-.79.52-.53-.09-1.05-.19-1.58-.28l-.04-.04Z"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m238.17,345.76c1.21-.92,1.77.5,1.82,1.61-.71,0-1.42-.02-2.13-.03.01-.56-.08-1.13.31-1.59Z"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m258.2,345.49c-.1.61-.21,1.21-.31,1.82-.53,0-1.05,0-1.58,0-.1-.67-.2-1.35-.29-2.02.62-.35,1.46-.19,2.14-.04,0,.08.02.16.04.24Z"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m254.42,346.11c.01-.19.03-.38.04-.58.31-.09.62-.18.93-.27-.32.28-.65.56-.97.85Z"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m204.47,335.66c-.34.05-.69.09-1.03.14-.02-.08-.04-.16-.04-.25.36.04.71.07,1.07.11Z"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m168.1,335.83c-.34-.05-.68-.11-1.03-.16.36-.02.72-.04,1.07-.06,0,.08-.02.15-.05.22Z"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m232.51,345.59c0,.09,0,.17.03.26-.07.19-.14.38-.21.56.06-.27.12-.55.19-.82Z"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m190.61,335.79c-.02-.08-.03-.16-.03-.25.23,0,.45,0,.68,0-.22.08-.43.16-.65.24Z"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m249.41,335.55c.13.06.25.13.38.19-.13-.06-.25-.13-.38-.19Z"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m176.87,335.51c-.01.08-.02.16-.03.24-.11-.07-.22-.15-.33-.22.12,0,.24-.01.36-.02Z"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m218.78,188.79c-1.22.35-2.49.41-3.74.24-2.39-4.01-1.63-3.87-6.43-5.53,3.6-3,10.76-3.37,13.87.71.35.96.42,1.92.28,2.93-1.19.88-2.57,1.28-3.98,1.65Z"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m250.03,140.16c.02.2.03.41.05.61-.77-.1-1.38-.35-1.24-1.31.4.23.79.47,1.19.7Z"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m248.49,138.92c.1,0,.2,0,.3.02,0,.09,0,.18-.04.27-.09-.09-.17-.19-.26-.28Z"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m250.01,200.97c.06.24.07.48.19.7-.14.08-.28.17-.42.25.08-.32.16-.63.24-.95Z"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m218.2,141.09c1.49,3.53.59,8.68,1.17,12.74.02.45-.39.91-.59,1.36-1.71-4.31-1.11-9.55-.58-14.11Z"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m250.4,142.02c1.29,2.83-1.19,16.69,1.22,16.9-.31.12-.62.24-.93.36-.21-.11-.42-.21-.63-.32.4-5.6-1.15-11.53.34-16.94Z"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m223.11,150.81c-.23,5.71.59,11.66-.24,17.25-.49-5.6-1.03-11.84.24-17.25Z"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m235.93,147.67c.05-2.31-.14-4.64.46-6.9.39-.31.77-.63,1.16-.94.6.96.73,1.66-.26,2.67-1.1,1.9,1.2,5.45-1.26,7.05-.03-.63-.07-1.25-.1-1.88Z"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m232.18,146.73c.05.84.09,1.67.14,2.51.74,1.14,1.84,1.07,3.04,1.04-4.09.76-5.11.58-3.18-3.55Z"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m216.26,174.34c0,1.03.3,2.19-.31,3.09-.09.02-.17.03-.26.04-.93-1.29-1.11-2.69-.98-4.24.52.37,1.04.74,1.56,1.11Z"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m217.86,153c.89,1.58,1.04,3.23.92,5.02-.29.31-.57.63-.86.94-.31-1.93-.11-3.99-.06-5.96Z"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m198.16,162.42c.91-.77-.03-1.87.33-2.83.8.9,2.97,5.61.69,5.74-.05-.03-.1-.06-.14-.09.02-.82-.31-1.59-.39-2.4-.15-.04-.31-.08-.46-.11-.05-.1-.06-.2-.02-.3Z"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m222.63,169.04c0,.09,0,.18,0,.27-.87.8-2.1.68-3.2.93-.53-.42-1.06-.84-1.58-1.26.01-.3.03-.61.04-.91.4.31.8.62,1.2.93,1.18.02,2.36.03,3.54.05Z"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m223.78,143.54c-.19.08-.38.17-.5.35-.02,1.16-.09,2.3-.18,3.47-1.08-1.04-1.43-2.92-.65-3.79.37-.41.87-1.18,1.32-.02Z"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m219.09,168.99c-.4-.31-.8-.62-1.2-.93-.21-.61-.36-1.23-.42-1.87v.02c.02-.12.04-.24.06-.35,2.16-1.19,1.45,1.94,1.56,3.14Z"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m199.49,155.54c1.13-1.31,3.1-.01,4.61-.04-1.54.01-3.07.03-4.61.04Z"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m245.11,149.24v-4.7c.83.92.83,3.78,0,4.7Z"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m226.65,145.79c-.03-.67-.06-1.34-.1-2.14-.53-.03-1.04.09-1.52-.1v-.58c.63,0,1.25,0,1.88,0,.19.95,1.22,2.34-.26,2.82Z"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m198.49,158.64c-.08-.76-.06-1.47.34-2.14,0,0-.03.01-.03.01.08-.14.18-.28.25-.43.09-.03.18-.06.27-.09.99,1.6.8,2.22-.82,2.64Z"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m210.03,171.86c1.16.4,2.31.8,3.47,1.2-1.56.79-2.59,0-3.47-1.2Z"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m239.23,138.01c.07.04.14.03.2-.03.52,0,1.04.02,1.56.02-.34.5-.68,1-1.01,1.49-.29-.4-.57-.81-.86-1.21.05-.09.08-.18.11-.28Z"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m222.53,138.01c1.04,0,2.09,0,3.13,0-.92.39-1.84.79-2.94,1.26-.08-.52-.13-.89-.19-1.25Z"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m244.43,143.65c-.93,0-1.86.05-2.79,0,1-1.3,2.47-1.3,3.4,0-.2,0-.4,0-.61,0Z"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m250.71,168.05c-.2.24-.41.48-.61.72-.03-1.06-1.38-2.5.84-2.91-.07.73-.15,1.46-.22,2.2Z"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m245.01,165.54c.03-.1.07-.21.1-.31,1.09,1.02,1.28,1.86.57,2.51-.18,0-.36,0-.54,0-.05-.73-.09-1.46-.14-2.19Z"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m200.35,170.13c-.13-.48-.26-.95-.4-1.43.56.74,2.19,1.02,1.07,2.49-.36-.26-.46-.68-.67-1.06Z"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m211.57,163.38c-.55-.4-.79-.95-.93-1.6.41-.03.83-.07,1.24-.1.03.61.05,1.19-.31,1.7Z"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m232.28,145.16c-.03.21-.07.42-.1.63-.46-1.2-.82-2.61-.04-3.75.16,1.04.15,2.08.14,3.12Z"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m210.64,161.78c.1.33.2.66.29.99-.3-.02-.6-.04-.9-.05-.11-.08-.21-.16-.32-.24-.68-.05-1.27-.47-1.91-.69.95,0,1.89,0,2.84,0Z"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m204.49,163.33c-.01.33.02.66-.15.96-1.33-.58-1.17-1.37-.33-2.27.15.34.3.68.45,1.02-.04.1-.03.2.03.29Z"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m255.07,163.3c-.71.3-1.34.89-2.14.82.42-1.3,1.25-1.62,2.14-.82Z"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m207.82,170.88c.66.3,1.32.6,1.97.9-.71-.18-1.9.68-1.97-.9Z"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m216.61,165.47c-.29-.2-.57-.4-.86-.59-.08-.19-.13-.38-.11-.59.87.05,1.87-.1,1.88,1.25-.31,0-.61,0-.91-.07Z"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m231.92,155.46c-.55,0-1.08-.01-1.59-.24,0,0,0,0,0,0,.39-.3.78-.6,1.17-.9.14.38.28.76.42,1.14Z"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m213.77,163.35c.38-.16.76-.33,1.13-.49.04.37.08.75.12,1.12-.59.21-.87-.26-1.25-.63Z"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m239.73,154.22c-.51.34-1.02.68-1.54,1.01,0-1.11.37-1.68,1.54-1.01Z"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m210.01,177.72c-.64.08-1.24-.47-1.85-.65-.01-.08-.03-.16-.06-.23.64-.11,1.28-.22,1.92-.33,0,.4,0,.8,0,1.2Z"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m210.01,177.72c0-.4,0-.8,0-1.2.42.5.83,1,1.25,1.5-.1.04-.21.08-.31.12l-.94-.42Z"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m237.55,139.83c-.39.31-.77.63-1.16.94.38-.53.76-1.07,1.15-1.6,0,.22,0,.44.01.66Z"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m249.89,169.04c-.67.29-1.34.58-2.02.88.67-.29,1.34-.58,2.02-.88Z"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m205.68,168.3c.15.04.31.08.46.12.2.5.41,1.01.61,1.51-.36-.54-.71-1.09-1.07-1.63Z"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m233.17,150.5c.52,0,1.04,0,1.56,0-.52.99-1.04.99-1.56,0Z"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m227.22,143.91c-.1-.31-.21-.63-.31-.94.27.04.54.08.82.13-.17.27-.33.54-.5.81Z"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m204.64,175.29c-.3-.2-.6-.41-.9-.61,0-.12.01-.24.02-.36.57.07,1.43-.13.88.97Z"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m252.66,173.79c.07,0,.15,0,.22.01-.07.62.29,1.51-.89,1.46.22-.49.45-.98.67-1.47Z"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m204.71,165.51c.19.06.37.11.56.17.11.14.22.28.33.42-.19.24-.37.47-.56.71-.11-.43-.22-.87-.33-1.3Z"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m241.73,144.54c-.14.53-.28,1.06-.42,1.59.09-.74.19-1.48.28-2.21.05.21.09.42.14.63Z"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m214.71,175.57c.21.42.42.84.63,1.25-.72-.16-1.29-.4-.63-1.25Z"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m202.16,173.08c-.12-.17-.23-.34-.35-.52.27-.04.53-.08.8-.12l-.45.63Z"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m214.39,158.08c.47.17.93.34,1.4.51-.6.21-1.37.87-1.4-.51Z"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m232.14,142.04c-.08.1-.15.2-.23.3-.19-.18-.38-.36-.57-.54.19-.13.37-.27.56-.4.08.21.16.43.24.64Z"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m263.81,161.48c-.4-.09-.81-.19-1.21-.28.61-.47,1.19-.71,1.55.27-.11,0-.23.01-.34.02Z"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m210.33,156.82c.31.1.63.21.94.31-.18.17-.36.35-.55.52-.13-.28-.26-.55-.39-.83Z"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m207.47,176.63c-.19-.06-.39-.11-.58-.17,0-.3,0-.59,0-.89.19.35.39.71.58,1.06Z"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m206.89,175.57c0,.3,0,.59,0,.89-.2.01-.39.02-.59.04-.02-.09-.04-.18-.04-.28.21-.22.42-.43.63-.65Z"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m245.11,162.09c0-.31,0-.63,0-.94.18.18.35.36.53.54l-.53.4Z"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m257.26,162.79c-.2-.01-.41-.02-.61-.03.31-.11.63-.21.94-.32-.11.12-.22.23-.33.35Z"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m214.39,163.96c-.1.01-.21.03-.31.04-.35-.21-.69-.41-1.04-.62.24-.01.49-.02.73-.04.21.2.42.41.63.61Z"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m242.56,138.01c.31,0,.63,0,.94,0-.18.18-.36.35-.54.53-.13-.18-.27-.35-.4-.53Z"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m220.34,138.35c.21,0,.42.01.63.02-.21.18-.42.36-.63.53,0-.18,0-.37,0-.55Z"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m220.34,138.35c0,.18,0,.37,0,.55-.24.09-.49.17-.73.26.05-.29.1-.59.14-.88.2.02.4.05.59.07Z"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m207.51,156.19c.32.09.63.17.95.26-.32-.09-.63-.17-.95-.26Z"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m225.03,142.97v.58c-.21,0-.42,0-.63,0,.21-.19.42-.38.63-.58Z"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m251.63,164.6c.21-.09.43-.18.64-.26,0,.09-.02.17-.03.26,0,0,0,0,0,0-.21.02-.41.03-.62.01Z"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m263.87,163.99c0-.22,0-.44-.01-.65.16.13.31.26.47.39-.15.09-.31.18-.46.26Z"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m226.65,147.04c0-.21,0-.42,0-.63.15.1.3.21.45.31-.15.1-.3.21-.45.31Z"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m263.81,161.48c.11,0,.23-.01.34-.02-.09.21-.17.42-.26.63-.03-.21-.05-.41-.08-.62Z"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m259.15,177.18c-.11.11-.22.23-.33.34-.1-.03-.21-.05-.31-.08.21-.09.43-.17.64-.26Z"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m261.95,161.42c-.2.03-.4.07-.6.1.11-.19.21-.37.32-.56.1.15.19.3.29.45Z"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m213.14,178.65c-.21,0-.42,0-.63,0,.11-.15.21-.3.32-.44.1.15.21.3.31.45Z"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m250.06,158.96c.21.11.42.21.63.32-.21-.11-.42-.21-.63-.32Z"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m212.51,157.37c.2.03.4.06.61.1-.2-.03-.4-.06-.61-.1Z"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m218.78,158.02v-.63c.16.13.33.26.49.39-.16.08-.33.16-.49.24Z"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m254.76,157.73c.31-.09.61-.18.92-.27-.31.09-.61.18-.92.27Z"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m252.88,158.32c.21-.08.42-.15.63-.23-.21.08-.42.15-.63.23Z"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m216.8,158.69c.03.09.06.18.11.27-.32-.11-.63-.22-.95-.33.28.02.56.04.84.06Z"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m245.14,167.73c.18,0,.36,0,.54,0-.02.25-.03.51-.05.76-.09-.03-.18-.07-.27-.11-.07-.22-.15-.44-.22-.65Z"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m216.93,165.53c.2,0,.4,0,.59,0,.01.22-.01.45-.06.67-.18-.22-.36-.45-.54-.67Z"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m205.02,161.11c-.21.03-.43.06-.64.09-.1-.04-.19-.05-.29-.02.31-.03.62-.05.94-.08Z"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m211.57,163.38c.11-.22.22-.44.32-.66,0,.31.05.63-.04.93l-.29-.27Z"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m240.94,152.9c-.09.03-.18.06-.27.1.09-.21.18-.41.27-.62,0,.17,0,.34,0,.52Z"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m269.15,156.14c.09.2.18.41.27.61-.09-.2-.18-.41-.27-.61Z"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m238.16,138.58c.2-.05.4-.1.59-.15-.2.05-.4.1-.59.15Z"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m269.47,157.38c.08.21.16.42.23.63-.08-.21-.16-.42-.23-.63Z"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m263.15,166.78c.11-.25.22-.49.33-.74-.11.25-.22.49-.33.74Z"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m205.33,167.7c.12.21.24.43.36.64-.12-.21-.24-.43-.36-.64Z"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m222.79,168.68c-.07.13-.14.26-.21.38.07-.13.14-.26.21-.38Z"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m199.46,166.78c-.07-.09-.08-.19-.04-.3.06.11.19.2.04.3Z"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m269.37,165.24c-.07.11-.14.21-.21.32.07-.11.14-.21.21-.32Z"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m263.56,165.54c.01-.11.02-.21.03-.32.04.13.14.25-.03.32Z"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m251.61,165.22c-.1,0-.19,0-.29.02.1-.11.2-.22.31-.33,0,0,.04.04.04.04-.02.09-.04.18-.05.27Z"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m206.88,170.26c.12.09.24.19.36.28-.12-.09-.24-.19-.36-.28Z"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m251.63,164.6c.12,0,.23,0,.35.01-.1.11-.21.22-.31.33,0,0-.04-.04-.04-.04,0-.1,0-.21,0-.31Z"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m207.53,170.68c.09.06.19.13.28.19-.09-.06-.19-.13-.28-.19Z"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m215.65,164.6c-.14-.09-.28-.18-.42-.27.14-.01.28-.03.42-.04,0,.1,0,.21,0,.31Z"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m215.02,164.25c-.15-.08-.31-.15-.46-.23.15-.02.31-.03.46-.05,0,.09,0,.19,0,.28Z"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m203.76,174.32c0,.12-.01.24-.02.36-.13-.11-.26-.22-.38-.32.13-.01.27-.02.4-.03Z"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m263.59,163.06c.09,0,.18,0,.26.04,0,.07-.01.14,0,.22-.08-.08-.17-.17-.26-.25Z"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m205.63,161.42c-.09.04-.19.06-.28.04-.03-.09-.06-.19-.08-.28l.36.24Z"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m253.55,178.29c0-.07-.02-.14-.04-.21.09.05.18.1.28.15-.07.03-.15.05-.23.06Z"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m214.11,178.4c-.11.08-.22.17-.34.25.11-.08.22-.17.34-.25Z"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m230.03,155.16c-.15-.08-.29-.16-.44-.23.15.08.29.16.44.23Z"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m235.94,150.14s.1.09,0,0c.09.1.04.05,0,0Z"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m248.21,138.68c.09.07.18.15.27.22-.09-.07-.18-.15-.27-.22Z"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m247.57,138.34c.13.07.26.14.38.22-.13-.07-.26-.14-.38-.22Z"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m221.91,138.03c.1-.03.19-.03.29,0-.1,0-.19,0-.29,0Z"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m279.46,207.77c2.62-.02,5.25.22,7.84-.27.23.22.46.45.69.67-1.8,2.11-3.27,4.7-5.41,6.52-1.91.59-9.65.22-7.61-2.98.93-1.58,2.5-3.8,4.49-3.94Z"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m296.67,230.79c-.1-.02-.19-.04-.29-.07-.01-.1,0-.19.04-.28.08.12.17.23.25.35Z"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m281.41,242.36c.06.11.18.2.02.3-.06-.09-.07-.19-.02-.3Z"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m315.46,310.05c.73.07,1.47.14,2.2.21-1.26.02-2.52.04-3.78.06.53-.09,1.05-.18,1.58-.28Z"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m313.29,310.72c.11-.1.22-.2.33-.31-.11.1-.22.2-.33.31Z"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m310.14,335.5c-2.02.62-4.17.22-6.26.33-2.47-2.52-3.55-6.41-5.84-9.22-.12.05-.25.11-.37.16-.13,2.91.32,5.92-.37,8.76-.1.08-.2.17-.31.25-2.29-.02-4.58.15-6.86-.04,0-8.44,0-16.88,0-25.33,6.34.06,14.91-2.03,18.79,4.36,1.2,4.3.22,8.2-3.43,10.97.43.49.77,1.03,1.07,1.6,0,.11.05.18.16.2,0,0,.04.07.04.07,1.64,2.49,3.61,4.74,3.39,7.89Zm-8.76-16.41c0-1.75-.44-2.11-2.87-2.08-1.27.02-.92,1.09-.85,1.75.1.99-.78,2.62,1.35,2.58,1.76-.03,2.37-.6,2.37-2.25Z"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m271.97,335.12c-3.97-1.49-5.54-4.72-6.89-8.46-3.01-28.61,33.39-15.99,17.65,6.54-.08,0-.13.04-.14.12-3.05,2.49-6.91,2.99-10.62,1.79Zm7.32-11.74c.37-3.73-3.01-8.74-6.13-4.59-4.38,6.46,4.5,15.45,6.13,4.59Z"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m319.53,302.28c-.84,0-1.68-.01-2.52-.02,0,0,.04-.1.04-.1-.55-1.36-.55-3.46,1.48-3.06.05.5.11,1,.16,1.48,3.57.72,3.84-4.26,1.17-4.72-.11-.57-.21-1.15-.32-1.72.21,0,.42,0,.62.01.11.08.23.16.34.24l.9-.02c3.12,1.8,2.78,8.32-1.87,7.93Z"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m316.76,300.98c.1.39.19.79.29,1.18-.1-.39-.19-.79-.29-1.18Z"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m291.7,310.27c-.22,0-.45,0-.67,0,.22,0,.45,0,.67,0Z"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m246.67,350.21c.19-.11.39-.22.58-.32,0,0,.04.04.04.04-.24.19-.43.49-.72.59.03-.1.07-.21.1-.31Z"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m246.69,350.49c.2-.19.4-.37.6-.56.53.09,1.05.19,1.58.28-.1.57-.21,1.14-.33,1.82,1.12-.13,2.53-.81,2.76.95-.31.24-.62.47-.93.71-1.35-.03-2.7-.06-4.06-.08-.14-.2-.27-.41-.41-.61-.05-.9.5-1.68.78-2.51Z"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m246.34,182.8c3.61-3.24,9.1-2.22,13.12-.36,0,.11.02.23.03.34-1.09.4-2.18.8-3.27,1.19-.1-.02-.17.02-.21.11-1.85.9-2.06,3.23-3.81,4.31-.1-.03-.19,0-.25.08-.25,0-.46.1-.65.26-.4,0-.8,0-1.2,0-3.8-1.13-7.3-1.3-3.76-5.93Z"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m197.74,352.39c0-1.56-.04-3.12.02-4.68.62-.1,1.25-.19,1.87-.29.05.33.21.64.31.96,0,0-.02,0-.02,0,1.02.64,3.19-.41,2.93,1.51-.09.07-.12.16-.1.27,0,0,0-.04,0-.04-4.4-.33-4.25,2.2.1,1.58,0,0,.05.04.05.04.1.11.21.2.29.32.08.13.15.26.23.4-.09.4-.19.8-.28,1.19-1.6-.43-5.24,1.1-5.39-1.26Z"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m192.5,345.55c.41,0,.82,0,1.23,0,.06,2.65.07,5.23.06,7.9-3.46,1.21-1.8-6.12-1.29-7.9Z"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m193.76,347.39c0-.61-.01-1.23-.02-1.84.89.14,1.94-.21,1.85,1.09-.47.35-1.07.39-1.54.71,0,0,0,0,0,0-.1-.01-.2,0-.3.03Z"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m186.29,348.63c-.23,1.57.98,6.35-1.94,4.72.13-2.62-.57-5.38.64-7.8,1.19.11,2.66-.28,3.43.87-.53.29-1.06.59-1.59.88-.18.44-.36.89-.54,1.33Z"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m190.3,347.12c-.39-.13-.79-.27-1.18-.4-.06-1.76,2.28-1.09,3.38-1.17-.23.72-.45,1.43-.68,2.15-.51-.19-1.01-.39-1.52-.58Z"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m216.33,214.6c-.88-1.55-.2-3.05.43-4.37.34-.71.09-2.22,1.65-2.05-.69,2.14-1.39,4.28-2.08,6.42Z"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m207.84,242.67c-.8-2.05-.47-2.96,1.17-3.14-.39,1.05-.78,2.1-1.17,3.14Z"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m210.34,236.1c.09-1.23-.21-2.71,1.72-2.81-.57.94-1.15,1.87-1.72,2.81Z"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m219.35,210.35c.21.3.42.6.63.9-.34.21-.68.43-1.02.64.13-.52.26-1.03.39-1.55Z"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m199.99,268.68c-.89-.75-.82-1.05.36-1.56-.12.52-.24,1.04-.36,1.56Z"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m212.56,232.46c.22-.35.45-.7.67-1.06-.22.35-.45.7-.67,1.06Z"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m214.11,229.89c.09-.13.18-.26.27-.39-.09.13-.18.26-.27.39Z"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m210.34,259.62c.08-.11.16-.22.24-.34-.08.11-.16.22-.24.34Z"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m214.4,229.48c.07-.09.14-.18.21-.28-.07.09-.14.18-.21.28Z"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m231.58,216.32c-.3.1-.6.19-.91.29-.86-.39-1.67-.88-2.45-1.41-.24-1.23-.18-2.5-.33-3.75,1.26-.75,2.51-1.35,4-1.34l1.49,1.29s-.01.02,0,.02c.05,1.01.1,2.02.16,3.03-.65.62-1.3,1.25-1.95,1.87Z"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m236.91,210.6c.98-.03,1.87.17,2.77.54,2.69,3.67-2.38,7.28-4.61,3.24-.13-.81-.06-1.62-.02-2.44h0c.1-.1.19-.21.29-.32.07-.01.11-.05.1-.13.39-.31.68-.79,1.18-.9.07.02.21.02.29,0Z"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m220.69,191.78c.49.35.98.7,1.46,1.06.05.19.11.38.16.57-.54-.54-1.09-1.08-1.63-1.63Z"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m224.05,202.22c-.09-.11-.17-.23-.26-.34.09.02.17.04.26.05.03.1.03.2,0,.29Z"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m267.59,259.26c-.26.1-.51.19-.77.29.26-.1.51-.19.77-.29Z"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m261.32,261.74c-.26.1-.51.21-.77.31.26-.1.51-.21.77-.31Z"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m216.27,195.95c-.08,0-.16,0-.24,0,.07-.12.15-.23.22-.35,0,.12,0,.23.01.35Z"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m215.31,199.36c-.07.11-.15.23-.22.34.07-.11.15-.23.22-.34Z"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m214.36,203c-.07.15-.13.3-.2.46.07-.15.13-.3.2-.46Z"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m199.05,253.3c-.07.12-.15.23-.22.35l.22-.35Z"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m250.38,198.79c.08-.32.17-.64.25-.97-.08.32-.17.64-.25.97Z"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m249.38,204.09c-.09.31-.17.62-.26.94.09-.31.17-.62.26-.94Z"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m202.8,241.09c.1-.37.2-.74.29-1.11-.1.37-.2.74-.29,1.11Z"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m282.87,251.29c-.06-.16-.11-.32-.17-.48.07,0,.14,0,.21.01-.02.16-.03.31-.05.47Z"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m167.13,310.27c.22,0,.44,0,.67,0-.22,0-.44,0-.67,0Z"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m166.62,335.66c-.13-.08-.25-.16-.38-.24.13.08.25.16.38.24Z"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m176.49,310.09c.02.08.04.16.06.25-.12,0-.24-.01-.35-.02.1-.08.19-.15.29-.23Z"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m242.24,335.46c-2.93.64-.46-20.09-1.19-23.51.75.54,2.01.91,2.09,1.97-.29,7.23.12,14.35-.89,21.55Z"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m261.28,328.56c-.98,1.89-1.77,4.37-4.01,5.04-.85-1.5,1.49-1.47,1.45-2.91-.08-1.95.68-2.63,2.56-2.13Z"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m253.14,327.76c.52-.81,1.04-1.62,1.56-2.44.37.67,1.23,1.65,1.04,1.95-.77,1.17-.89,3.09-3.17,3.1.2-.93.39-1.77.57-2.61Z"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m248.81,317.22c-.12.44-.24.87-.37,1.31-1.84.08-1.27-2.04-.95-3.11.21-.01.43-.03.64-.04.22.61.45,1.23.67,1.84Z"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m254.79,324.8c0-.84,0-1.67,0-2.51.94.84.95,1.67,0,2.51Z"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m262.51,321.69c.02.2.04.4.06.59-.02-.2-.04-.4-.06-.59Z"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m241.29,310.33c.22-.01.44-.02.66-.03-.22.01-.44.02-.66.03Z"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m252.44,328.21c.15-.08.29-.17.44-.25-.15.08-.29.17-.44.25Z"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m241.07,311c-.05-.1-.04-.2.04-.28.03.11.11.22-.04.28Z"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m189.26,312.3c-.08,0-.17-.01-.25-.04,0-.42.02-.84.02-1.26.1-.11.21-.21.31-.32-.03.54-.06,1.08-.09,1.62Z"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m196.75,310.43c.16.19.32.38.48.58-.09.1-.17.21-.26.31-.07-.3-.15-.59-.22-.89Z"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m189.66,335.47c-.09-.11-.19-.23-.28-.34.09.11.19.23.28.34Z"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m189.35,310.68c.11-.1.22-.19.33-.29-.11.1-.22.19-.33.29Z"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m229.04,326.37c0-.32,0-.63,0-.95,0,.32,0,.63,0,.95Z"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m228.93,327.69c.03-.13.06-.26.09-.39-.03.13-.06.26-.09.39Z"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m229,311.33c-.04-.13-.14-.26.04-.33-.01.11-.03.22-.04.33Z"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m209.03,332.64c0-1.05-.02-2.1-.03-3.14,0,1.05.02,2.1.03,3.14Z"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m208.79,334.25c.08-.12.16-.25.23-.37-.08.12-.16.25-.23.37Z"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m209,328.57c-.05-.13-.17-.25,0-.34,0,.11,0,.22,0,.34Z"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m208.98,311.33c-.04-.13-.14-.26.04-.33-.01.11-.03.22-.04.33Z"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m330.79,302.27c-1.66-.02-3.31-.04-4.97-.06v-8.09h1.84c.02.71.09,1.42.05,2.14-.26,2.4,4.13.08,2.76,2.5-.89.11-1.81.08-2.69.08-.42,2.51.93,2.46,2.69,1.85h-.01c.19.14.39.27.64.3-.1.43-.2.86-.31,1.29Z"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m327.73,295.76c-.02-.54-.05-1.09-.07-1.63,1.33-.04,2.66-.41,3.52.89-.13.21-.26.43-.38.64-1.02.13-2.05-.03-3.06.1Z"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m207.48,353.63c-.2.02-.4.04-.6.06-.89-2.5-1.16-5.72,0-8.15,1.14.01,2.28,0,3.42.04,3.36,1.67.69,3.04.32,5.55-.43.13-.86.26-1.29.39-.51-.36-1.02-.73-1.87-1.34v3.44Zm1.6-6.32c-.35-.28-.7-.56-1.05-.84-1.44,1.84.39,3.88,1.96,1.77-.3-.31-.61-.62-.91-.93Z"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m220.07,352.56c-1.5.83-3.02,1.21-4.74,1.03-.18-.29-.36-.59-.55-.88,0-.63,0-1.26,0-1.89.04-.7-.05-1.69,0-2.51.12-.3-.13-.84-.08-1.25.42-.5.83-1,1.25-1.5.73,0,1.46-.01,2.19,0,.3.43.45.92.57,1.43-.48-.17-.99-.04-1.49-.03-1.74.85-.69,3.14-.95,4.68,1.45.28,2.56.23,3.11-1.17.43.33.86.66,1.28.99l-.59,1.11Z"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m220.67,351.45c-.43-.33-.86-.66-1.28-.99.19-1.31-.65-2.9-.91-4.32.11-.18.21-.36.32-.54.83.61,1.69,1.15,2.15,2.11,0,0-.01-.01-.01-.01.16,1.14.1,2.29.04,3.44-.1.11-.21.21-.31.32Z"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m202.85,351.7c-4.36.61-4.48-1.91-.1-1.58.03.53.06,1.06.1,1.58Z"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m200.3,345.54h3.04c-.21.62-.35,1.04-.49,1.45-.97.13-1.86-.03-2.71.34-.04-.06-.1-.11-.16-.15.1-.55.21-1.09.31-1.64Z"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m200.3,345.54c.07,1.84-1.16,2.23-2.79,2.13.21-.73.41-1.46.62-2.18.21-.03.43-.06.64-.09,0,0,.14.05.14.05.47-.07.95,0,1.42,0l-.03.1Z"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m209.35,351.52c.43-.13.86-.26,1.29-.39.14.18.27.36.41.54,0,0-.02,0-.02,0,.46.6.78,1.29,1.17,1.93-.4,0-.8.01-1.2.02-.55-.7-1.1-1.4-1.65-2.1Z"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m215.95,345.56c-.42.5-.83,1-1.25,1.5-.47-1.39-.36-1.53,1.25-1.5Z"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m218.8,345.6c-.11.18-.21.36-.32.54-.11-.19-.22-.39-.34-.58.22.01.44.03.66.04Z"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m214.78,352.71l.55.88c-.1.02-.21.05-.31.07-.08-.32-.16-.63-.24-.95Z"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m210.31,345.58c-.31,0-.61-.02-.92-.03.31,0,.61.02.92.03Z"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m207.51,345.54c-.2,0-.41,0-.61,0,.2,0,.41,0,.61,0Z"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m217.52,345.55c-.1,0-.21,0-.31,0,.1,0,.21,0,.31,0Z"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m199.9,347.52c-.08.03-.16.06-.25.07,0-.06-.01-.11-.02-.16.06-.03.13-.05.19-.08.04.05.07.11.08.18Z"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m214.77,348c.05.12.18.22.01.31,0-.1,0-.21-.01-.31Z"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m214.77,350.51c.05.12.18.22.01.31,0-.1,0-.21-.01-.31Z"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m211.04,351.68c-.06-.07-.11-.15-.17-.22.11.03.17.11.17.22Z"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m203.15,352.01c-.09-.09-.17-.18-.26-.27.09.09.17.18.26.27Z"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m211.3,352.06c-.09-.13-.19-.26-.28-.38.09.13.19.26.28.38Z"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m203.41,352.46c-.08-.13-.15-.26-.23-.4.08.13.15.26.23.4Z"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m239.9,346.72c-.06-.18-.12-.37-.18-.55.05,0,.11.01.16.03,0,.17.02.34.03.51Z"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m271.65,302.28c-1.58-.12-3.16-.25-4.74-.37.03-.21.05-.41.08-.62.17-.38-.19-1.06-.07-1.58,0,0,.12.02.12.02.21-.16-.09-.41-.12-.64.54-.89-.25-3.92,1.51-2.85.64,1.53,2.01,1.17,3.22,1.24.06.07.14.1.23.08-.08.39-.16.78-.25,1.17-1.27-.05-2.46-.13-3.41.87.78,1.62,1.93,1.43,3.43,1.03.72.55,1.21,1.1,0,1.64Z"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m264.08,302.09c-.6.02-1.19.05-1.79.07-.2-.39-.39-.78-.59-1.18.09.01.19.02.28.03.22-2.1.26-4.21.23-6.32.44-.24.87-.48,1.31-.72.1.03.2.06.3.09.78,2.53.08,5.37.25,8.02Z"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m272.35,295.02c-.13.22-.25.44-.38.66-1.19.11-2.56-.29-3.53.56-1.62-1.04-1.08,1.64-1.4,2.54-.16-1.46-.18-2.93-.07-4.39.22-.15.44-.3.65-.44,1.65.27,3.61-.52,4.73,1.07Z"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m278.23,294.14c-.1.58-.21,1.17-.31,1.75-.28.04-.56.07-.84.11-.35-.62-.69-1.25-1.04-1.87.73,0,1.46,0,2.19.01Z"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m275.17,294.7c.02-.18.03-.37.05-.55.07.02.14.05.2.08-.08.16-.17.31-.25.47Z"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m267.04,299.41c.05.12.16.23,0,.32,0-.11,0-.21,0-.32Z"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m267.02,300.98c.04.13.15.24-.02.31,0-.1.02-.21.02-.31Z"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m271.65,300.64c-1.5.4-2.65.59-3.43-1.03.95-1,2.15-.92,3.41-.87,0,.63.01,1.26.02,1.9Z"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m232.48,353.47c-.05-.35-.09-.71-.14-1.06.05.35.09.71.14,1.06Z"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m232.34,350.81c-.06-.1-.07-.2-.02-.3.05.11.17.21.02.3Z"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m178.1,347.31c-.32,0-.63,0-.95,0,.15-.37.31-.73.46-1.1.1,0,.2,0,.3.01.06.36.12.72.18,1.09Z"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m177.18,345.27c.31.07.63.14.94.21l-.94-.21Z"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m277.08,296c.28-.04.56-.07.84-.11.28.46.55.91.83,1.37-.54.14-1.08.28-1.62.42-.02-.56-.04-1.12-.05-1.68Z"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m169.01,347.11c.32.37.64.73.96,1.1-2.2,2.82-3.99-1.88-.96-1.1Z"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m169.34,345.55c.43.08.86.15,1.3.23-.43-.08-.86-.15-1.3-.23Z"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m169.01,347.11c-.2-.05-.4-.1-.6-.15.2.05.4.1.6.15Z"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m166.26,345.59c.1-.02.19,0,.28.03-.09.16-.17.32-.26.48,0-.17-.01-.35-.02-.52Z"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m167.15,345.54c.1,0,.21,0,.31,0-.1,0-.21,0-.31,0Z"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m168.4,345.55c.1,0,.21,0,.31,0-.1,0-.21,0-.31,0Z"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m295.08,297.14c.15.92.3,1.83.46,2.83-1.92-.34-2.17-1.27-.46-2.83Z"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m226.99,352.02c-.46.08-.91.1-1.38.03,0-1.48-.17-2.96.65-4.27.17.04.35.07.52.11.07,1.38.14,2.75.21,4.13Z"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m184.99,345.54c-.23.62-.46,1.24-.7,1.85-.39.04-.77.02-1.15-.04-.33-.3-.65-.61-.98-.91,0,0-.02,0-.02,0,.08-.25.15-.5.23-.75.87-.05,1.75-.1,2.62-.15Z"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m187.82,345.8c-.21-.06-.42-.13-.63-.19.21.06.42.13.63.19Z"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m285.07,296.83c1.26,1.12,2,2.42,1.89,4.13-1.84.08-2.84-2.4-1.89-4.13Z"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m248.82,345.85c-.11.42-.22.84-.34,1.26-.2.08-.4.15-.59.23-.76-.3-1.52-.6-2.41-.96,1.21-1.41,2.3-.66,3.34-.53Z"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m217.53,157.06c.08-.1.17-.2.25-.3,0,.11,0,.23,0,.34-.09-.01-.17-.02-.26-.03Z"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m198.84,163.97c.06.22.12.43.18.65-.06-.22-.12-.43-.18-.65Z"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m198.18,162.72c.15.04.31.07.46.11-.15-.04-.31-.07-.46-.11Z"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m223.76,179c-.42,0-.85.02-1.27.02.02-.3.03-.61.05-.91,2.93-5.7,5.4-11.73,8.07-17.57.61-2.27,5.73-1.35,7.53-.88-.01.1.02.18.1.24,1.61,3.21,2.54,6.58,3.96,9.87,1.38,2.18,1.91,4.86,3.1,7.18-.04.07-.03.14.03.2.05.35.1.7.31,1,0,0-.02.01-.02.02.18,3.01-4.43-.79-5.72-1.4-2.74-2.25-3.53,2.95-5.48,4.22-5.17-5.73-3.55-5.83-10.67-1.97,0,0,0-.01,0-.01Z"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m217.48,166.8c0-.2-.01-.41-.02-.61.04.3.08.6.12.91-.03-.1-.07-.2-.1-.3Z"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m230.33,155.22c.21.07.42.14.63.21-.21-.07-.42-.14-.63-.21Z"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m217.77,145.49c-.05-.13-.16-.25.01-.34,0,.11,0,.22-.01.34Z"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m217.78,155.83c0-.32,0-.64-.01-.95,0,.32,0,.64.01.95Z"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m320.15,294.14c.11.08.23.16.34.24-.11-.08-.23-.16-.34-.24Z"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m209.08,347.31c.3.31.61.62.91.93-.98,1.42-2.81,1.1-2.46-.81.52-.04,1.03-.08,1.55-.11Z"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m209.08,347.31c-.52.04-1.03.08-1.55.11.16-.32.33-.64.49-.96.35.28.7.56,1.05.84Z"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m218.32,346.89c-.37.02-.73.05-1.1.07.37-.02.73-.05,1.1-.07Z"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m219.45,350.19v-.31c.05.12.18.23,0,.31Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlijdorp);
export default __webpack_public_path__ + "static/media/blijdorp.ca530f46395a23facb8217008ecdd3aa.svg";
export { ForwardRef as ReactComponent };